import {
    ValueTypeEnum, CannabisSection, CannabisAnswer, CannabisOption, CannabisOptionNested,
    QuestionTypeEnum, WidthTypeEnum, CenterRadius, FifteenOption, PartnerNamesEnum
} from './shared';

export const EmptyAnswer = () => {
    return {
        selected: false,
        inputValue: '',
        freeTextInputValue: '',
        option: { Label: '', Code: '' },
        options: [],
        cards: [],
        perscriptions: [],
        thcCbdGroup: {},
        medikamenteTable: [],
        titrationsplan: {}
    } as CannabisAnswer;
}

export const freitext = "Freitext";
export const etwasAnderes = "Etwas anderes (Freitext)";
export const stationareFreitext = "Stationäre Aufenthalte";

export const sindSieList: CannabisOption[] = [
    { Label: "weiblich" },
    { Label: "männlich" },
    { Label: "divers" }
];
export const jaNeinList: CannabisOption[] = [
    { Label: "Ja" },
    { Label: "Nein" }
];

export const CannabisJSON: CannabisSection[] = [
    {
        sectionNumber: 1,
        expanded: true,
        title: 'Indikation',
        questions: [
            {
                stepper: 'Zu behandelnde Diagnose',
                questionNumber: 1,
                question: "Welches Beschwerdebild soll mit Medizinalcannabis behandelt werden?",
                questionDesc: `Hier ist nur eine Einfachnennung möglich. Bitte geben Sie hier die Hauptindikation an. Angaben zu weiteren Indikationen können später bei Punkt 4. <i>Welche anderen Erkrankungen bestehen gleichzeitig?</i> ergänzt werden. Bitte beachten Sie, dass sich die Auswahlmöglichkeiten der folgenden Fragen je nach Indikation anpassen`,
                questionInfo: `<p>Erläutern Sie die Erkrankung des Patienten (m/w/d), welche mit Cannabinoiden behandelt werden soll. Die Gesetzgebung legt keine bestimmten Erkrankungen und Symptome fest, jedoch müssen sie schwerwiegend sein.</p>
<p>In einem dreistufigen Auswahlverfahren können Sie die zu behandelnde Diagnose spezifizieren. Wie bei allen folgenden Fragen haben Sie die Möglichkeit über Freitext-Felder die Angaben weiter zu konkretisieren. Darüber hinaus besteht die Möglichkeit eine Diagnose, die nicht gelistet ist, über eine integrierte Funktion aus einer ICD 10 List auszuwählen. Dazu drücken Sie bitte das Stift Symbol.</p>`,
                hideAnswer: true,
                answer: EmptyAnswer(),
                questions: [
                    {
                        questionNumber: 1,
                        question: "Beschwerdebild:",
                        questionType: QuestionTypeEnum.NUMBER,
                        valueType: ValueTypeEnum.OPTION,
                        options: [
                            { Label: 'Schmerz' },
                            { Label: 'Spastik' },
                            { Label: 'Übelkeit und Erbrechen' },
                            { Label: 'Appetitlosigkeit' },
                            { Label: 'Neurologische Erkrankungen' },
                            { Label: 'Psychiatrische Erkrankungen' },
                            { Label: 'Chronische Erkrankungen' },
                            { Label: 'Palliativbehandlung' }
                        ],
                        answer: EmptyAnswer()
                    },
                    {
                        questionNumber: 2,
                        question: "Diagnose Indikation Cannabistherapie:",
                        questionType: QuestionTypeEnum.NUMBER,
                        valueType: ValueTypeEnum.OPTION,
                        options: [],
                        answer: EmptyAnswer(),
                        hasDynamicOptions: true,
                        dynamicOptions: []
                    },
                    {
                        questionNumber: 3,
                        question: "Relevante Zusatzdiagnose",
                        questionType: QuestionTypeEnum.NUMBER,
                        valueType: ValueTypeEnum.OPTION,
                        options: [],
                        answer: EmptyAnswer(),
                        extraInput: freitext,
                        placeholder: freitext,
                        hasDynamicOptions: true,
                        dynamicOptions: []
                    }
                ]
            },
            {
                stepper: 'Medikamente',
                questionNumber: 2,
                question: 'Welche Medikamente nimmt der Patient bislang gegen das Beschwerdebild ein?',
                questionInfo: `<p>Führen Sie alle in der Vergangenheit erfolgten und zurzeit erfolgenden medikamentösen Therapien für die Erkrankung auf.</p>
                                <p>Dem Beschwerdebild entsprechend können Sie aus einer Liste vorsortierter Medikament auswählen. Des Weiteren bestehet die Möglichkeit, weitere Medikament zu wählen oder über Freitext weitere anzuführen.</p>
                                <p>In zweiten Schritt geben Sie bitte Wirkstoff, Dosis und Behandlungsdauer der Medikation an. Sie können diese im (1-1-1-1) Schema angeben oder Angaben in Form von Freitext eingeben. Es ist zu empfehlen, die bisherige Therapie zu kommentieren, z. B. wie über Nebenwirkungen oder ob die aktuelle Therapie mit Beginn der Medizinalcannabistherapie fortgeführt werden soll.</p>`,
                valueType: ValueTypeEnum.OPTIONS,
                options: [],
                answer: EmptyAnswer(),
                orderBy: 'Label',
                groupBy: 'Tooltip',
                questions: [
                    {
                        questionNumber: 1,
                        question: "Weitere Medikamente",
                        questionType: QuestionTypeEnum.EXPAND,
                        expanded: false,
                        valueType: ValueTypeEnum.OPTIONS,
                        options: [],
                        answer: EmptyAnswer(),
                        extraInput: freitext,
                        placeholder: freitext,
                        showFilter: true,
                        fuzzyFilter: true,
                        filterText: "",
                        orderBy: 'Label',
                        groupBy: 'Tooltip'
                    },
                    {
                        questionNumber: 2,
                        question: "Freitext",
                        questionType: QuestionTypeEnum.EXPAND,
                        expanded: false,
                        valueType: ValueTypeEnum.TEXTAREA,
                        widthType: WidthTypeEnum.FULL,
                        placeholder: "Freitext",
                        answer: EmptyAnswer()
                    }
                ]
            },
            {
                hideForPartners: [PartnerNamesEnum.SWISS],
                stepper: 'Wirkung der Medikamente',
                questionNumber: 3,
                question: 'Beschreiben Sie die Wirkung, die der Patient bisher verspürt hat, wenn die Medikamente eingenommen wurden.',
                questionInfo: `<p>Bitte geben Sie die positiven, sowie negativen Wirkungen an, die mit den Medikamenten der bisherigen Therapie einhergehen. Wichtig ist, dass hieraus erkennbar wird, dass keine andere, dem medizinischen Standardentsprechende Leistung zur Verfügung steht oder unter Abwägung der Nebenwirkungennicht zur Anwendung kommen kann.</p>`,
                hideAnswer: true,
                answer: EmptyAnswer(),
                questions: [
                    {
                        questionNumber: 1,
                        question: 'Positive Wirkungen',
                        questionType: QuestionTypeEnum.IMAGE,
                        image: "/images/medizinisches/plus sign.svg",
                        valueType: ValueTypeEnum.OPTIONS,
                        options: [],
                        extraInput: etwasAnderes,
                        placeholder: etwasAnderes,
                        answer: EmptyAnswer()
                    },
                    {
                        questionNumber: 2,
                        question: 'Negative Wirkungen',
                        questionType: QuestionTypeEnum.IMAGE,
                        image: "/images/medizinisches/minus sign.svg",
                        valueType: ValueTypeEnum.OPTIONS,
                        options: [],
                        extraInput: etwasAnderes,
                        placeholder: etwasAnderes,
                        answer: EmptyAnswer()
                    },
                    {
                        questionNumber: 3,
                        question: "Weitere Angaben zum bisherigen Medikationsplan (Freitext)",
                        questionType: QuestionTypeEnum.EXPAND,
                        expanded: false,
                        valueType: ValueTypeEnum.TEXTAREA,
                        widthType: WidthTypeEnum.FULL,
                        placeholder: "Freitext",
                        answer: EmptyAnswer()
                    }
                ]
            },
            {
                stepper: 'Welche anderen Erkrankungen',
                questionNumber: 4,
                question: 'Welche anderen Erkrankungen bestehen gleichzeitig?',
                questionInfo: `<p>Erläutern Sie koexistierende Erkrankungen und wie diese sich ggf. durch Kontraindikationen auf andere Therapieformen auswirken können. Bitte geben Sie die komplette Bezeichnung und ICD-Klassifikation der Erkrankung(en) an.</p>
<p>Bitte geben Sie diese Information über das Freitext Feld an. Des Weiteren steht Ihnen die Funktion aus einer ICD 10 List auszuwählen zur Verfügung. Dazu drücken Sie bitte das Stift Symbol.</p>`,
                valueType: ValueTypeEnum.OPTIONS,
                options: [
                    { Label: freitext }
                ],
                answer: EmptyAnswer(),
                extraInput: freitext,
                placeholder: freitext,
                hasDynamicOptions: true,
                dynamicOptions: []
            }
        ]
    },
    {
        sectionNumber: 2,
        expanded: true,
        title: "Cannabinoidbehandlung",
        questions: [
            {
                hideForPartners: [PartnerNamesEnum.FOUR_20_PHARMA],
                stepper: 'Cannabinoidkonzentration',
                questionNumber: 1,
                question: "Cannabinoidkonzentration",
                questionInfo: `<p>Die Cannabispflanze enthält ca. 140 verschiedene Cannabinoide, die sogenannten Phytocannabinoide (Phyto; griech. für Pflanze), wobei Tetrahydrocannabinol (THC) und Cannabidiol (CBD) die beiden Hauptwirkstoffe darstellen.</p>
<p>In der Pflanze existieren diese überwiegend in ihrer sauren Form (THCA, CBDA). Erst durch Einwirkung von Hitze entstehen die bioaktiven, d. h. vom Körper aufnahmefähigen, Moleküle THC und CBD. Diesen Schritt nennt man Decarboxylierung. Bei Cannabigerol, Cannabichromen und Cannabinol handelt es sich um weitere interessante Phytocannabinoide, deren Pharmakologie und Wirkung derzeit erforscht werden.</p>
<p><strong>THC – Tetrahydrocannabinol</strong></p>
<p>THC bzw. Dronabinol ist das am besten untersuchte Phytocannabinoid. In den meisten Cannabissorten stellt THC das Cannabinoid mit der höchsten Konzentration dar und verursacht die psychotrope Wirkung von Medizinalcannabis. Es bindet an die Endocannabinoidrezeptoren CB1 und CB2 mit Auswirkungen auf das zentrale und periphere Nervensystem.</p>
<p>Wichtige therapeutische Wirkungen sind Schmerzlinderung, Muskelentspannung, Appetitsteigerung sowie Verminderung von Übelkeit und Erbrechen.</p>
<p><strong>CBD – Cannabidiol</strong></p>
<p>CBD weist im Gegensatz zu THC keine psychotropen Wirkungen auf und stellt in den meisten Cannabissorten das zweithäufigste Phytocannabinoid dar. Es kann den psychoaktiven Effekt von THC hemmen und somit bei vielen Patienten zu einer besseren Verträglichkeit führen.</p>
<p>Es ist weniger gut charakterisiert als THC, so ist z. B. der Wirkmechanismus noch nicht genau bekannt. Zwei seltene Epilepsieformen bei Kindern sind die einzigen gesicherten Indikationen. Jedoch werden derzeit u. a. entkrampfende, angstlösende, antipsychotische sowie entzündungshemmende Wirkungen erforscht.</p>
<p><strong>Cannabinoidkonzentration Empfehlung</strong></p>
<p>Um ihre Entscheidungsfindung bezüglich der Cannabinoidkonzentration zu unterstützen, verweisen wir auf die wissenschaftlichen Erkenntnisse aktueller Publikationen.</p>
<p>Der Ratgeber ‚Medical Grade Cannabis - Clinical Guide’ der auch ‚Green Book’ genannt wird, ist der offizielle Cannabisleitfaden des israelischen Gesundheitsministeriums für die klinische Behandlung mit Medizinalcannabis.</p>
<p>Dieser klinische Leitfaden stellt eine einheitliche, zentrale Methodik dar, die Ärzten als Instrument zur Erstellung eines Behandlungsplans, zur Empfehlung der Dosierung sowie Auswahl eines Cannabisprodukts dient.</p>
<p>Basierend auf Forschungserkenntnissen, der Analyse wissenschaftlicher Literatur sowie den praktischen Erfahrungen israelischer Mediziner und Cannabis Experten aus den Bereichen Botanik, Pharmakologie, Chemie und Biochemie wird eine ‚therapeutische Methodik definiert, die unteranderem Empfehlungen für den Einsatz spezifischer Cannabinoidkonzentration bei bestimmten Indikationen gibt.</p>
<p>Das Buch wurde von Yuval Landschaft, Direktor der Abteilung für medizinisches Cannabis in Israel und Prof. Rafael Mechoulam, der Pionier der Cannabisforschung, geschrieben und herausgegeben. An der Veröffentlichung sind des weiteren Prof. Yoram Shapira, Prof. Meir Biler, Prof. Arnon Afek, Dr. Boaz Lev, Dr. Michael Dor, Dr. Eyal Schwartzberg sowie Dr. Paula Roska und Boaz Elbo beteiligt.</p>
<p>Copeia bemüht sich, alle angebotenen Informationen aktuell und vollständig zur Verfügung zu stellen. Für eine Vollständigkeit und Richtigkeit dieser Informationen sowie Aktualität wird keine Gewähr übernommen.</p>`,
                valueType: ValueTypeEnum.THC_CBD_GROUP,
                answer: EmptyAnswer()
            },
            {
                displayForPartners: [PartnerNamesEnum.FOUR_20_PHARMA],
                stepper: 'Cannabinoidkonzentration',
                questionNumber: 1,
                question: "Cannabinoidkonzentration",
                questionInfo: `<p>Die Cannabispflanze enthält ca. 140 verschiedene Cannabinoide, die sogenannten Phytocannabinoide (Phyto; griech. für Pflanze), wobei Tetrahydrocannabinol (THC) und Cannabidiol (CBD) die beiden Hauptwirkstoffe darstellen.</p>
<p>In der Pflanze existieren diese überwiegend in ihrer sauren Form (THCA, CBDA). Erst durch Einwirkung von Hitze entstehen die bioaktiven, d. h. vom Körper aufnahmefähigen, Moleküle THC und CBD. Diesen Schritt nennt man Decarboxylierung. Bei Cannabigerol, Cannabichromen und Cannabinol handelt es sich um weitere interessante Phytocannabinoide, deren Pharmakologie und Wirkung derzeit erforscht werden.</p>
<p><strong>THC – Tetrahydrocannabinol</strong></p>
<p>THC bzw. Dronabinol ist das am besten untersuchte Phytocannabinoid. In den meisten Cannabissorten stellt THC das Cannabinoid mit der höchsten Konzentration dar und verursacht die psychotrope Wirkung von Medizinalcannabis. Es bindet an die Endocannabinoidrezeptoren CB1 und CB2 mit Auswirkungen auf das zentrale und periphere Nervensystem.</p>
<p>Wichtige therapeutische Wirkungen sind Schmerzlinderung, Muskelentspannung, Appetitsteigerung sowie Verminderung von Übelkeit und Erbrechen.</p>
<p><strong>CBD – Cannabidiol</strong></p>
<p>CBD weist im Gegensatz zu THC keine psychotropen Wirkungen auf und stellt in den meisten Cannabissorten das zweithäufigste Phytocannabinoid dar. Es kann den psychoaktiven Effekt von THC hemmen und somit bei vielen Patienten zu einer besseren Verträglichkeit führen.</p>
<p>Es ist weniger gut charakterisiert als THC, so ist z. B. der Wirkmechanismus noch nicht genau bekannt. Zwei seltene Epilepsieformen bei Kindern sind die einzigen gesicherten Indikationen. Jedoch werden derzeit u. a. entkrampfende, angstlösende, antipsychotische sowie entzündungshemmende Wirkungen erforscht.</p>`,
                valueType: ValueTypeEnum.THC_CBD_GROUP,
                answer: EmptyAnswer()
            },
            {
                stepper: 'Form der Therapie',
                questionNumber: 2,
                question: "In welcher Form soll die medikamentöse Therapie mit Cannabis erfolgen?",
                questionInfo: `<p>Bitte wählen Sie aus, in welcher Form das Medizinalcannabis verordnet werden soll. Hierbei können Sie zwischen oraler Anwendung oder Inhalation und den entsprechenden Arzneimittelgruppen wählen.</p>
                                <p><strong>Inhalative vs orale Anwendung:</strong></p>
                                <p><strong>Inhalative Anwendung:</strong></p>
                                <ul>
                                    <li>Wirkungseintritt in weniger als 5 Minuten</li>
                                    <li>Wirkungsdauer: 2-3 Stunden</li>
                                    <li>Theoretische Bioverfügbarkeit: 15-35%</li>
                                    <li>Erzielter Wirkspiegel ist stark abhängig von der Inhalationstechnik</li>
                                    <li>Gut steuerbar</li>
                                    <li>Verordnung muss speziell begründet werden</li>
                                </ul>

                                <p><strong>Orale Anwendung:</strong></p>
                                <ul>
                                    <li>Wirkungseintritt in 30-90 Minuten</li>
                                    <li>Wirkungsdauer: 4-8 Stunden</li>
                                    <li>Bioverfügbarkeit: 3-12%</li>
                                    <li>Wirkspiegel kann durch gleichzeitige Nahrungsmittelaufnahme schwanken</li>
                                    <li>Einfache Anwendung</li>
                                    <li>Vorsichtige Dosistitration über mehrere Tage bis Wochen</li>
                                </ul>
                                
                                <p>Blüten sind vornehmlich für die Inhalation mit einem Vaporisator gedacht, jedoch ist auch die Zubereitung von Tee möglich.</p>
                                <p>Die Extrakte und Dronabinol sind in öliger Form erhältlich und werden oral eingenommen. Die Apotheke kann zudem Dronabinolkapseln herstellen.</p>
                                <p>Die Auswahl von Fertigarzneimittel ist noch relativ übersichtlich: Canames in Kapselform und Sativex als Spray zur Anwendung in der Mundhöhle (Marinol mit dem Wirkstoff Dronabinol als Kapsel ist nur teilweise verfügbar).</p>
                                <p>Cannabisextrakte mit den Hauptwirkstoffen THC und CBD sind ölige Lösungen zur Herstellung eines Rezepturarzneimittels in der Apotheke. Die Vollextrakte werden unter strengen GMP-Regularien mittels CO2-Extraktion oder Ethanolextraktion in standardisierter Qualität hergestellt. Neben der konstanten Wirkstoffkonzentration von THC und CBD sind auch weitere Cannabinoide und pharmakologisch wirksame sekundäre Pflanzenstoffe (z.B. Terpene) enthalten.</p>    
                                <p><strong>Für den Antrag zu beachten:</strong></p>
                                <p>Die Anforderungen der Angaben für den Kostenübernahmeantrag unterscheiden sich bei den Krankenkassen. In manchen Fällen ist es ausreichend, die Arzneimittelform der Cannabinoidtherapie anzugeben, wie bspw. Cannabisblüten oder Cannabisextrakt. In anderen Fällen ist die Auswahl des spezifischen Produkts erforderlich. Im Zweifelsfall sollte dies mit der Krankenversicherung vorab geklärt werden.</p>
                                <p><strong>Begründung der Verordnung von Cannabisblüten</strong></p>
                                <p>Die Verordnung von Cannabis in Form von getrockneten Blüten ist in dem Antrag auf Kostenübernahme zu begründen.</p>
                                `,
                valueType: ValueTypeEnum.INHALATIV_ORAL,
                answer: EmptyAnswer(),
                questions: [
                    {
                        questionNumber: 1,
                        question: "Begründung für die Verordnung von Blüten:",
                        questionDesc: "Die Verordnung von getrockneten Blüten ist hier insbesondere zu begründen. (§ 44 Verordnungsvoraussetzungen)",
                        options: [
                            { Label: "Aufgrund der Notwendigkeit einer akuten Symptomlinderung, soll die Therapie durch eine inhalative Anwendung erfolgen. Der Wirkspiegel wird bei Inhalation deutlich schneller erzielt, als bei der oralen Applikation." },
                            { Label: "Durch die inhalative Anwendung von Cannabisblüten werden die zu behandelten Symptome deutlich stärker als bei der oralen Anwendung gelindert, weil die zusätzlichen Inhaltsstoffe der Cannabisblüten die therapeutische Wirkung verstärken." },
                            { Label: "Aufgrund der massiven Beeinträchtigung der Lebensqualität bei akut auftretenden Symptomen, besteht die Notwendigkeit, die Dosierung durch den:die Patient:in zur raschen Symptomlinderung eigenständig zu regulieren." },
                            { Label: "Der Bedarf an einer hohen THC-Plasmakonzentration zur Symptomlinderung ist sehr hoch und kann nur durch die inhalative Anwendung von Cannabisblüten erzielt werden." },
                            { Label: etwasAnderes }
                        ],
                        hideBorder: true,
                        valueType: ValueTypeEnum.OPTIONS,
                        extraInput: etwasAnderes,
                        placeholder: etwasAnderes,
                        answer: EmptyAnswer()
                    },
                    {
                        questionNumber: 2,
                        question: "Quellenangaben:",
                        options: [
                            { Label: "Wilsey, Barth L et al. “A preliminary evaluation of the relationship of cannabinoid blood concentrations with the analgesic response to vaporized cannabis.” Journal of pain research vol. 9 587-98. 31 Aug. 2016, doi:10.2147/JPR.S113138" },
                            { Label: "Russo, Ethan B. “Taming THC: potential cannabis synergy and phytocannabinoid-terpenoid entourage effects.” British journal of pharmacology vol. 163,7 (2011): 1344-64. doi:10.1111/j.1476-5381.2011.01238.x" },
                            { Label: "Fiz, Jimena et al. “Cannabis use in patients with fibromyalgia: effect on symptoms relief and health-related quality of life.” PloS one vol. 6,4 e18440. 21 Apr. 2011, doi:10.1371/journal.pone.0018440" },
                            { Label: "Newmeyer, Matthew N et al. “Free and Glucuronide Whole Blood Cannabinoids' Pharmacokinetics after Controlled Smoked, Vaporized, and Oral Cannabis Administration in Frequent and Occasional Cannabis Users: Identification of Recent Cannabis Intake.” Clinical chemistry vol. 62,12 (2016): 1579-1592. doi:10.1373/clinchem.2016.263475" },
                            { Label: "Wallace, Mark S et al. “Efficacy of Inhaled Cannabis on Painful Diabetic Neuropathy.” The journal of pain vol. 16,7 (2015): 616-27. doi:10.1016/j.jpain.2015.03.008" }
                        ],
                        hideBorder: true,
                        valueType: ValueTypeEnum.LIST,
                        answer: EmptyAnswer(),
                        buttonText: 'Quellen übernehmen'
                    }
                ]
            },
            {
                stepper: 'Produkt Und Dosierung',
                questionNumber: 3,
                question: "Cannabisprodukt wählen und die Dosierung angeben",
                questionInfo: `<p>Über eine fortlaufend aktualisierte Datenbank erhalten Sie einen Überblick über die in Deutschland vertriebenen Medizinalcannabisprodukte. Wir bemühen uns diese Auflistung aktuell zu halten, übernehmen aber keine Verantwortung für die Vollständigkeit dieser Liste.</p>
<div>Über diese Applikation können Sie:</div>
<ul>
    <li>Ein spezifisches Cannabisprodukt auswählen</li>
    <li>Produkte nach der Form des Medizinalcannabis-Produkte filtern</li>
    <li>Produkte nach Konzentration der Cannabinoide THC und CBD filtern</li>
    <li>Produkte nach Cultivar und Dominanz filtern</li>
</ul>
<p>Des Weiteren bieten wir einen Überblick über die einzelnen Chargen dieser Produkte.</p>
<p>Bei einem pflanzlichen Produkt wie Cannabis kommt es naturgemäß zu schwankenden Konzentrationen der Inhaltsstoffe. Detailliertes Wissen über die Inhaltsstoffe, vor allem der Cannabinoide, ist ausschlaggebend für eine erfolgreiche und optimal auf die Patienten Bedürfnisse zugeschnittene Therapie.</p>
<p>Jede einzelne Charge (engl. Batches) des Cannabis wird von unabhängigen Laboren auf die konkrete Konzentration der Inhaltsstoffe und eventuelle Kontamination geprüft. Die Laboranalyse informiert über die Konzentration der Cannabinoide und garantiert, dass das Cannabis nach pharmazeutischen Qualitätsstandards hergestellt wurde. Wir bieten Ihnen nun den Zugriff auf diese Informationen und schafft damit einen wichtigen Schritt für eine transparente Cannabis-Therapie. Mehr erfahren: <a href="https://copeia.de/" target="_blank">https://copeia.de/</a></p>
<p>Für den Antrag wählen Sie bitte das Produkt aus, nicht eine einzelne Charge.</p>
<p><strong>Rechner zur Kalkulation der Tagesdosis sowie derGesamtmenge der Verordnung</strong></p>
<p>Der Rechner unterstütz den Arzt bei der Angabe und Berechnung des THC(mg) Gehalts der einzelnen Dosis, der täglichen Menge an THC und der Berechnung des entsprechenden Gewichts des Medizinalcannbisprodukts. Ausgehend für die Berechnung ist die THC Konzentration des einzelnen Produkts. Diese Angaben entnehmen Sie der Übersicht der Medizinalcannabisprodukte.</p>
<p>Nach Auswahl der Form des Medizinalcannabisprodukts, wählen Sie bitte auch die Darreichungsform aus. Das System wählt dann die entsprechende NRF (Neue Rezeptur-Formularium) aus und gibt diese an. Das NRF ist das Standardwerk für die Arzneimittelherstellung in der Apotheke. Die Angabe der NRF ist zu empfehlen, aber nicht zwingend erforderlich für die Verordnung der Cannabistherapie.</p>
<p><strong>Vorgaben der DAC/NRF-Rezepturvorschrift:</strong></p>
<p>Die Art der Anwendung und die Gebrauchsanweisung kann der Arzt durch Verordnung der Nummer der DAC/NRF-Rezepturvorschrift bestimmen:</p>
<ul>
    <li>Cannabisblüten zur Inhalation nach Verdampfung (NRF 22.12.)</li>
    <li>Cannabisblüten in Einzeldosen zur Inhalation nach Verdampfung (NRF 22.13.)</li>
    <li>Cannabisblüten zur Teezubereitung (NRF 22.14.)</li>
    <li>Cannabisblüten in Einzeldosen zur Teezubereitung (NRF 22.15.)</li>
    <li>Ölige Cannabisölharz-Lösung 25 mg/ml</li>
    <li>Ethanolische Dronabinol-Lösung 10 mg/ml zur Inhalation (NRF 22.16.)</li>
    <li>Dronabinol-Kapseln 2,5 mg / 5 mg / 10 mg (NRF 22.7.)</li>
    <li>Ölige Dronabinol-Tropfen 25 mg/ml (NRF 22.8.)</li>
    <li>Ölige Cannabidiol-Lösung 50 mg/ml (NRF 22.10.)</li>
</ul>
<p>Anmerkung: Cannabisblüten können auch ohne NRF-Vorschrift verschrieben werden, um in unverarbeiteter Form von der Apotheke abgegeben zu werden.</p>
<img src="/images/medizinisches/dosage-table.svg" alt="dosage-table.png" />
`,
                valueType: ValueTypeEnum.PERSCRIPTIONS,
                answer: EmptyAnswer()
            },
            {
                displayForPartners: [PartnerNamesEnum.SWISS],
                stepper: 'Titrationsplan',
                questionNumber: 5,
                question: 'Titrationsplan',
                questionInfo: `<p>Titrationsplan</p>`,
                valueType: ValueTypeEnum.TITRATIONSPLAN,
                answer: EmptyAnswer()
            },
            {
                stepper: 'Verdampfer / Inhalator',
                questionNumber: 4,
                question: "Ist für die Behandlung ein medizinischer Verdampfer / Inhalator notwendig?",
                questionInfo: `<p>Mit der Bewilligung der Therapie von medizinischen Cannabis-Blüten ist die Verordnung eines medizinischen Inhalators bzw. Verdampfer als Hilfsmittel zulasten der Krankenkasse zulässig:</p>
                                <p>Volcano Medic, PZN: 15885501, PPN: 111588550156<br/>
                                Stationäres Gerät, Inhalation über ein Schlauchteil oder einen Ventilballon.</p>
                                <p>Mighty Medic, PZN: 15634236, PPN: 111563423659<br />
                                Tragbarer Cannabisinhalator, Inhalation über Mundstück</p>
                                <p>Die Beantragung eines mobilen sowie eines stationären Verdampfers ist möglich. In Einzelfällen muss die Notwendigkeit begründet werden</p>
                                `,
                valueType: ValueTypeEnum.OPTIONS,
                options: [
                    { Label: "Volcano Medic Verdampfungssystem (PZN: 15885501)" },
                    { Label: "Mighty Medic Verdampfungssystem (PZN: 15634236)" },
                    { Label: "Kein Verdampfungssystem notwendig" },
                    { Label: freitext }
                ],
                extraInput: freitext,
                placeholder: freitext,
                answer: EmptyAnswer()
            }
        ]
    },
    {
        sectionNumber: 3,
        expanded: true,
        title: "Begründung der Therapie",
        questions: [
            {
                hideForPartners: [PartnerNamesEnum.SWISS],
                stepper: 'Palliativversorgung',
                questionNumber: 1,
                question: "Erfolgt die Verordnung im Rahmen einer Palliativbehandlung?",
                questionDesc: "<p class='mt-2 mb-2'>Erfolgt die Verordnung von Cannabisarzneimitteln im Rahmen der Versorgung einer SAPV (Spezialisierte ambulante Palliativversorgung), entfällt der Genehmigungsvorbehalt der Krankenkasse für die Kostenübernahme der Therapie mt Cannabisarzneimitteln.</p><p class='mb-2'>Bei einer Allgemeinen Ambulanten Palliativversorgung (AAPV) oder einer Anschlussverordnung aufgrund einer Versorgung mit Cannabisarzneimitteln im Rahmen eines stationären Krankenhausaufenthaltes hat die Krankenkasse innerhalb von 3 Tagen zu entscheiden.</p>",
                questionInfo: `<p>Die Krankenkasse hat bei
<ul>
<li><strong>Anschlussverordnung</strong> aufgrund einer Versorgung mit Cannabisarzneimitteln im Rahmeneines stationären Krankenhausaufenthalts oder</li>
<li>bei Verordnungen im Rahmen einer <strong>Allgemeinen Ambulanten Palliativversorgung (AAPV)</strong></li>
</ul>
innerhalb von <strong>3 Tagen</strong> zu entscheiden.</p>
<p><strong>Versäumnis der Frist</strong></p>
<p>Wenn die Frist von 3 Tagen <strong>ohne schriftliche Begründung</strong> von der Krankenkasse verstrichen ist, müssen die Kosten der Therapie von der Versicherung übernommen werden.</p>
<p><strong>SAPV (Spezialisierte ambulante Palliativversorgung)</strong></p>
<p>Erfolgt die Verordnung von Cannabisarzneimitteln im Rahmen der Versorgung einer SAPV, <strong>entfällt der Genehmigungsvorbehalt</strong> der Krankenkasse für die Kostenübernahme der Therapie mit Cannabisarzneimitteln.</p>
<p><strong>Sozialgesetzbuch (SGB) Fünftes Buch (V) - Gesetzliche Krankenversicherung - (Artikel 1 des Gesetzes v. 20. Dezember 1988, BGBl. I S. 2477)</strong></p>
<p><strong>§ 37b Spezialisierte ambulante Palliativversorgung</strong></p>
<p>Versicherte mit einer nicht heilbaren, fortschreitenden und weit fortgeschrittenen Erkrankung bei einer zugleich begrenzten Lebenserwartung, die eine besonders aufwändige Versorgung benötigen, haben Anspruch auf spezialisierte ambulante Palliativversorgung. Die Leistung ist von einem Vertragsarzt oder Krankenhausarzt zu verordnen. Die spezialisierte ambulante Palliativversorgung umfasst ärztliche und pflegerische Leistungen einschließlich ihrer Koordination insbesondere zur Schmerztherapie und Symptomkontrolle und zielt darauf ab, die Betreuung der Versicherten nach Satz 1 in der vertrauten Umgebung des häuslichen oder familiären Bereichs zu ermöglichen; hierzu zählen beispielsweise Einrichtungen der Eingliederungshilfe für behinderte Menschen und der Kinder- und Jugendhilfe. Versicherte in stationären Hospizen haben einen Anspruch auf die Teilleistung der erforderlichen ärztlichen Versorgung im Rahmen der <strong>spezialisierten ambulanten Palliativversorgung</strong>. Dies gilt nur, wenn und soweit nicht andere Leistungsträger zur Leistung verpflichtet sind. Dabei sind die besonderen Belange von Kindern zu berücksichtigen.</p>
<p><strong>§ 7 Satz 2 der SAPV-RL</strong></p>
<p>Die ärztliche Verordnung erfolgt auf einem zu vereinbarenden Vordruck, der der Leistungserbringung nach dem jeweiligen aktuellen Versorgungsbedarf (§ 5 Abs. 2) Rechnung zu tragen hat und Angaben zur Dauer der Verordnung enthält.</p>
<p><strong>§ 8 Satz 1 der SAPV-RL</strong></p>
<p>Die Krankenkasse übernimmt bis zu einer Entscheidung über die weitere Leistungserbringung die Kosten für die verordneten und von den Leistungserbringern nach § 132d SGB V erbrachten Leistungen entsprechend der vereinbarten Vergütung nach § 132d SGB V, wenn die Verordnung gemäß § 7 Abs. 2 spätestens an dem dritten der Ausstellung folgenden Arbeitstag der Krankenkasse vorgelegt wird.</p>
<p><strong>§ 13 Kostenerstattung Absatz 3a Satz 1 SGB V</strong></p>
<p>Die Krankenkasse hat über einen Antrag auf Leistungen zügig, spätestens bis zum Ablauf von <strong>drei Wochen</strong> nach Antragseingang oder in Fällen, in denen eine gutachtliche Stellungnahme, insbesondere des <strong>Medizinischen Dienstes</strong>, eingeholt wird, innerhalb von <strong>fünf Wochen</strong> nach Antragseingang zu entscheiden. Wenn die Krankenkasse eine gutachtliche Stellungnahme für erforderlich hält, hat sie diese unverzüglich einzuholen und die Leistungsberechtigten hierüber zu unterrichten. Der Medizinische Dienst nimmt innerhalb von drei Wochen gutachtlich Stellung. (...)</p>
<p>Kann die Krankenkasse Fristen nach Satz 1 oder Satz 4 nicht einhalten, teilt sie dies den Leistungsberechtigten unter Darlegung der Gründe <strong>rechtzeitig schriftlich oder elektronisch mit</strong>; für die elektronische Mitteilung gilt § 37 Absatz 2b des Zehnten Buches entsprechend. Erfolgt <strong>keine Mitteilung eines hinreichenden Grundes, gilt die Leistung nach Ablauf der Frist als genehmigt</strong>. Beschaffen sich Leistungsberechtigte nach Ablauf der Frist eine erforderliche Leistung selbst, ist die Krankenkasse zur Erstattung der hierdurch entstandenen Kosten verpflichtet.</p>
`,
                options: [
                    { Label: "Die Verordnung erfolgt im Rahmen einer Spezialisierte ambulante Palliativversorgung (SAPV)." },
                    { Label: "Die Verordnung erfolgt im Rahmen einer Allgemeinen Ambulanten Palliativversorgung (AAPV)." },
                    { Label: "Es handelt sich um eine Anschlussverordnung aufgrund einer Versorgung mit Cannabisarzneimitteln im Rahmen eines stationären Krankenhausaufenthalts." },
                    { Label: "Es handelt sich um keine Palliativversorgung." }
                ],
                valueType: ValueTypeEnum.OPTION,
                answer: EmptyAnswer()
            },
            {
                hideForPartners: [PartnerNamesEnum.SWISS],
                stepper: 'Erkrankungsschwere',
                questionNumber: 2,
                question: "Ist die Grunderkrankung oder mehrere Erkrankungen zusammen schwerwiegend?",
                questionInfo: `<p>Zur Bewilligung des Antrags muss eine schwerwiegende Erkrankung vorliegen, welche mit körperlichen, psychischen und sozialen Beeinträchtigungen einhergeht. Eine schwerwiegende Erkrankung liegt vor, wenn sie lebensbedrohlich ist oder aufgrund der Schwere der durch sie verursachten Gesundheitsstörung auf Dauer die Lebensqualität nachhaltig beeinträchtigt.</p>
<p>Eine schwerwiegende Erkrankung ist besonders dann gegeben, wenn eine der schwerwiegenden Erkrankungen im Sinne der höchstrichterlichen Rechtsprechung vorliegt. Schwerwiegende Erkrankungen werden weiter auch in der Richtlinie des Gemeinsamen Bundesausschusses zur Umsetzung der Regelungen in § 62 für schwerwiegend chronisch
Erkrankte definiert (<a href="https://www.g-ba.de/downloads/62-492-1530/RL-Chroniker_2017-11-17.pdf" target="_blank">https://www.g-ba.de/downloads/62-492-1530/RL-Chroniker_2017-11-17.pdf</a>).</p>
<p>In anderen Fällen ist die konkrete, individuelle Situation des Patienten (m/w/d) ausschlaggebend, welche durch eine genaue Differentialdiagnose, ausführlichen Krankheitsverlauf sowie möglichst genaue Angaben zur Symptomatik und Beeinträchtigung erläutert werden sollte.</p>
<p>Schwerwiegende Symptome stellen in diesem Zusammenhang auch durch bisher angewandte Arzneimittel verursachte Nebenwirkungen dar. Onkologisch und seitens des G-BA werden Nebenwirkungen (<a href="https://ctep.cancer.gov/protocolDevelopment/electronic_applications/ctc.htm" target="_blank">https://ctep.cancer.gov/protocolDevelopment/electronic_applications/ctc.htm</a>) ab Grad 3 als „schwerwiegend“ eingestuft.</p>
<p>Befundunterlagen, Arzt- und Krankenhausberichte, sowie ein kurzer Patientenbericht zur Beschreibung der beeinträchtigten Lebensqualität sollten angefügt werden. Die Dauer der Symptome oder Erkrankung ist anzugeben.</p>
`,
                valueType: ValueTypeEnum.OPTIONS,
                options: [
                    { Label: "Ja, die Erkrankung ist schwerwiegend" },
                    { Label: "Austherapiert" },
                    { Label: "Klare infauste Prognose" },
                    { Label: "Progredienter/fudroyanter Verlauf" },
                    { Label: etwasAnderes }
                ],
                extraInput: etwasAnderes,
                placeholder: etwasAnderes,
                answer: EmptyAnswer()
            },
            {
                stepper: 'Therapieziel',
                questionNumber: 3,
                question: "Wie lautet das Behandlungsziel?",
                questionInfo: `<p>Erläutern Sie die zu erwartende, positive Wirkung von Medizinalcannabis auf den Krankheitsverlauf bzw. auf die schwerwiegenden Symptome. Es ist hilfreich, die Behandlungsziele so genau wie möglich zu erläutern. Das Ziel der Behandlung der Grunderkrankung mit Cannabinoiden ist nicht zwingend erforderlich. Sollte Aussicht auf Besserung schwerwiegender Symptome bestehen, gilt dies auch als Begründung.</p>`,
                valueType: ValueTypeEnum.OPTIONS,
                options: [],
                extraInput: etwasAnderes,
                placeholder: etwasAnderes,
                answer: EmptyAnswer()
            },
            {
                stepper: 'Weitere Therapien',
                questionNumber: 4,
                question: "Welche bisherige Therapie ist mit welchem Erfolg bisher durchgeführt worden?",
                questionInfo: `<p>Führen Sie alle in der Vergangenheit erfolgten Therapien zu der Erkrankung bzw. den Erkrankungen auf. Dem Beschwerdebild entsprechend können Sie aus einer Vorauswahl wählen. Wichtig ist, dass hieraus erkennbar wird, dass keine andere, dem medizinischen Standard entsprechende Leistung zur Verfügung steht oder unter Abwägung der Nebenwirkungen nicht zur Anwendung kommen kann. Bitte geben Sie an, ob die aktuelle Therapie mit Beginn der Medizinalcannabis-Therapie fortgeführt werden soll.</p>`,
                valueType: ValueTypeEnum.OPTIONS,
                options: [],
                extraInput: etwasAnderes,
                placeholder: etwasAnderes,
                freeTextInput: stationareFreitext,
                answer: EmptyAnswer()
            },
            {
                hideForPartners: [PartnerNamesEnum.SWISS],
                stepper: 'Begründung',
                questionNumber: 5,
                question: "Warum stehen allgemein anerkannte, dem medizinischen Standard entsprechende alternative Behandlungsoptionen nicht zur Verfügung?",
                questionInfo: `<p>Für eine positive Antwort auf den Antrag sollte die Antwortmöglichkeit „Es steht keine allgemein anerkannte, dem medizinischen Standard entsprechende Leistung als Alternative zur Behandlungmit Cannabis zur Verfügung“ ausgewählt werden.</p>
<p>Eine Alternative kann auch dann nicht zur Verfügung stehen, wenn eine Behandlung bereits erfolglos durchgeführt wurde oder wegen Kontraindikationen oder nachvollziehbaren, nicht tolerierbaren Nebenwirkungen keine Option darstellt. Hierfür ist eine plausible Begründung notwendig (s. folgend). Für einen erfolgreichen Antrag muss eine begründete und nachvollziehbare Einschätzung vorliegen, dass derartige Alternativen bzw. Leistungen nicht zur Anwendung kommen können. Zu den vorformulierten Textblöcken, können Sie diese über die Freitext Funktion ergänzen. Diese Begründung sollte unter Abwägung der zu erwartenden Nebenwirkungen und unter Berücksichtigung des Krankheitszustandes des Versicherten erfolgen.</p>
<p>Es ist auch zu begründen, welche Vorteile die Cannabisanwendung gegenüber Leistungen hinsichtlich der Anwendungssicherheit bietet. Sollten bei anderen Arzneimitteln Nebenwirkungen aufgetreten sein, welche die Behandlung mit Cannabis rechtfertigen, sind diese plausibel, wenn sie in der Fachinformation aufgeführt sind. SolltenNebenwirkungen aufgetreten sein, von denen in der Fachinformation nicht berichtet wird, ist die Meldung der unerwünschten Arzneimittelwirkung beim BfArM zu belegen. Generell ist kein Vollbeweis nötig.</p>
<p>In jedem Fall ist für einen erfolgreichen Antrag die Auswahl der Antwortmöglichkeit „Es besteht eine nicht ganz entfernt liegende Aussicht auf eine spürbare positive Einwirkung auf den Krankheitsverlauf oder auf schwerwiegende Symptome“ zu empfehlen. Diese Aussage ist weiter zu begründen.</p>
`,
                valueType: ValueTypeEnum.OPTIONS,
                options: [
                    { Label: "Es steht keine allgemein anerkannte, dem medizinischen Standard entsprechende Leistung als Alternative zur Behandlung mit Cannabis zur Verfügung" },
                    { Label: "Es besteht eine nicht ganz entfernt liegende Aussicht auf eine spürbare positive Einwirkung auf den Krankheitsverlauf oder auf schwerwiegende Symptome" },
                    { Label: "Andere Medikamentengruppen kommen, insbesondere aufgrund ihres Nebenwirkungsprofils, nicht in Betracht" },
                    { Label: etwasAnderes }
                ],
                extraInput: etwasAnderes,
                placeholder: etwasAnderes,
                answer: EmptyAnswer()
            },
            {
                stepper: 'Literatur',
                questionNumber: 6,
                question: "Bitte benennen Sie Literatur, aus der hervorgeht, dass eine nicht ganz entfernt liegende Aussicht auf eine spürbare positive Einwirkung auf den Krankheitsverlauf oder auf schwerwiegende Symptome besteht.",
                questionInfo: `<p>Geben Sie Literaturquellen an, welche eine positive Aussicht des Krankheitsverlaufsdurch die Cannabistherapie nahelegt. Dem Beschwerdebild entsprechend liegt Ihnen eine Vorauswahl von Literatur vor. Diese Quellen weisen eine hohe Evidenzstufe aus.</p>
<p>Des Weiteren besteht die Möglichkeit über die Literaturverzeichnis App weitere Quellen auszuwählen. Die Applikation öffnen Sie, indem Sie auf das + (Plus) Symbol drücken. Mit dieser Anwendung können Sie gezielt weitere Literatur die aktuell auf PubMed zur Verfügung steht auswählen. Der Algorithmus der Anwendung gliedert hierbei die Literatur nach Relevanz.</p>
<div><strong>Evidenz</strong></div>
<p>Wegen der gleichlautenden Formulierung im Hinblick auf die Maßstäbe an die Evidenz im § 2 Abs. 1a SGB V und im § 31 Abs. 6 SGB V (nicht ganz entfernt liegende Aussicht auf eine spürbare positive Einwirkung auf den Krankheitsverlauf) ist zum jetzigen Zeitpunkt davon auszugehen, dass die gleichen Kriterien an das Erkenntnismaterial zu stellen sind.</p>
<p>Die vom behandelnden Arzt und ggf. selbst recherchierten Unterlagen sind gemäß der Verfahrens-ordnung des G-BA zu klassifizieren.</p>
<p>Für therapeutische Methoden gelten nach der Verfahrensordnung des G-BA (Stand: 20.10.2016) folgende Evidenzstufen:</p>
<ul>
    <li>Ia Systematische Übersichtsarbeiten von Studien der Evidenzstufe I b.</li>
    <li>Ib Randomisierte klinische Studien</li>
    <li>IIa Systematische Übersichtsarbeiten von Studien der Evidenzstufe II b</li>
    <li>IIb Prospektive vergleichende Kohortenstudien</li>
    <li>III Retrospektive vergleichende Studien</li>
    <li>IV Fallserien und andere nicht vergleichende Studien</li>
    <li>V Assoziationsbeobachtungen, pathophysiologische Überlegungen, deskriptive Darstellungen, Einzelfallberichte u. ä.; nicht mit Studien belegte Meinungen anerkannter Experten, Berichte von Expertenkomitees und Konsensuskonferenzen.</li>
</ul>
<p>Die höchste Evidenz beinhaltet dementsprechend die Stufe Ia.</p>
`,
                valueType: ValueTypeEnum.CARDS,
                answer: EmptyAnswer()
            },
            {
                hideForPartners: [PartnerNamesEnum.SWISS],
                stepper: 'Klinische Studie',
                questionNumber: 7,
                question: "Erfolgt die Cannabinoidtherapie im Rahmen einer klinischen Prüfung?",
                questionInfo: "<p>Nicht gemeint ist die anonymisierte Begleituntersuchung, welche der Arzt (m/w/d) für das Bundesministerium für Arzneimittel und Medizin durchzuführen hat</p>",
                options: jaNeinList,
                valueType: ValueTypeEnum.OPTION,
                answer: EmptyAnswer()
            }
        ]
    },
    {
        sectionNumber: 4,
        expanded: true,
        title: "Namen und Adressen für die Versicherung",
        questions: [
            {
                stepper: "Patient-in",
                questionNumber: 1,
                question: "Patient-in",
                questionInfo: `<p>Bitte geben Sie hier die Persönlichen Informationen des Patienten, sowie die Krankenkassen Versicherungsnummer an.</p>`,
                hideAnswer: true,
                answer: EmptyAnswer(),
                hideBorder: true,
                questions: [
                    {
                        questionNumber: 1,
                        question: "Vorname:",
                        valueType: ValueTypeEnum.INPUT,
                        widthType: WidthTypeEnum.HALF,
                        answer: EmptyAnswer()
                    },
                    {
                        questionNumber: 2,
                        question: "Nachname:",
                        valueType: ValueTypeEnum.INPUT,
                        widthType: WidthTypeEnum.HALF,
                        answer: EmptyAnswer()
                    },
                    {
                        questionNumber: 3,
                        question: "Geboren am:",
                        valueType: ValueTypeEnum.DATE,
                        widthType: WidthTypeEnum.HALF,
                        answer: EmptyAnswer()
                    },
                    {
                        questionNumber: 4,
                        question: "Geschlecht:",
                        valueType: ValueTypeEnum.SELECT,
                        widthType: WidthTypeEnum.HALF,
                        options: sindSieList,
                        answer: EmptyAnswer()
                    },
                    {
                        questionNumber: 5,
                        question: "Versicherungsnummer:",
                        valueType: ValueTypeEnum.INPUT,
                        widthType: WidthTypeEnum.FULL,
                        answer: EmptyAnswer()
                    }
                ]
            },
            {
                stepper: "Versicherung",
                questionNumber: 2,
                question: "Versicherung",
                questionInfo: `<p>Bitte geben Sie hier die Informationen der Versicherung des Patienten (m/w/d) an.</p>`,
                hideAnswer: true,
                answer: EmptyAnswer(),
                hideBorder: true,
                questions: [
                    {
                        questionNumber: 1,
                        question: "Gesetzliche Krankenkasse:",
                        valueType: ValueTypeEnum.FILTER_SELECT,
                        widthType: WidthTypeEnum.FULL,
                        answer: EmptyAnswer()
                    },
                    {
                        questionNumber: 2,
                        question: "Straße:",
                        valueType: ValueTypeEnum.INPUT,
                        widthType: WidthTypeEnum.FULL,
                        answer: EmptyAnswer()
                    },
                    {
                        questionNumber: 3,
                        question: "Ort:",
                        valueType: ValueTypeEnum.INPUT,
                        widthType: WidthTypeEnum.HALF,
                        answer: EmptyAnswer()
                    },
                    {
                        questionNumber: 4,
                        question: "PLZ:",
                        valueType: ValueTypeEnum.INPUT,
                        widthType: WidthTypeEnum.HALF,
                        answer: EmptyAnswer()
                    }
                ]
            },
            {
                stepper: "Behandelnder Arzt",
                questionNumber: 3,
                question: "Behandelnder Arzt",
                questionInfo: `<p>Bitte geben Sie hier die Persönlichen Informationen des behandelnden Arztes (m/w/d) an.</p>`,
                hideAnswer: true,
                answer: EmptyAnswer(),
                hideBorder: true,
                questions: [
                    {
                        questionNumber: 1,
                        question: "Name der Praxis oder des Arztes:",
                        valueType: ValueTypeEnum.INPUT,
                        widthType: WidthTypeEnum.FULL,
                        answer: EmptyAnswer()
                    },
                    //{
                    //    questionNumber: 2,
                    //    question: "KV Nummer:",
                    //    valueType: ValueTypeEnum.INPUT,
                    //    widthType: WidthTypeEnum.FULL,
                    //    answer: EmptyAnswer()
                    //},
                    {
                        questionNumber: 3,
                        question: "Straße:",
                        valueType: ValueTypeEnum.INPUT,
                        widthType: WidthTypeEnum.FULL,
                        answer: EmptyAnswer()
                    },
                    {
                        questionNumber: 4,
                        question: "Ort:",
                        valueType: ValueTypeEnum.INPUT,
                        widthType: WidthTypeEnum.HALF,
                        answer: EmptyAnswer()
                    },
                    {
                        questionNumber: 5,
                        question: "PLZ:",
                        valueType: ValueTypeEnum.INPUT,
                        widthType: WidthTypeEnum.HALF,
                        answer: EmptyAnswer()
                    }
                ]
            }
        ]
    }
];

export const QuestOneOptions: CannabisOptionNested[] = [
    {
        Label: "Schmerz",
        options: [
            {
                Label: "Chronische unbeeinflussbare Schmerzen",
                Code: "R52.1",
                options: [
                    {
                        Label: "Migräne",
                        Code: "G43"
                    },
                    {
                        Label: "Chronische Schmerzstörung mit somatischen und psychischen Folgen",
                        Code: "F45.41"
                    },
                    {
                        Label: "Chronische rheumatische Neuritis",
                        Code: "M79.29"
                    },
                    {
                        Label: "Andauernde Persönlichkeitsänderung bei chronischem Schmerzsyndrom",
                        Code: "F62.80"
                    },
                    {
                        Label: "Leberzellkrebs",
                        Code: "C22.9"
                    },
                    {
                        Label: "Fibromyalgie",
                        Code: "M79.7"
                    }
                ]
            },
            {
                Label: "Chronisches Schmerzsyndrom",
                Code: "R52.2",
                options: [
                    {
                        Label: "Freitext (Ursache Schmerz)"
                    }
                ]
            },
            {
                Label: "Tumorschmerz",
                Code: "R52.1",
                options: [
                    {
                        Label: "Metastasierendes Karzinom",
                        Code: "C79.9"
                    },
                    {
                        Label: "Paliativbehandlung",
                        Code: "Z51.5"
                    },
                    {
                        Label: "Knochenschmerzen",
                        Code: "M89.89"
                    }
                ]
            },
            {
                Label: "Polyneuropathie",
                Code: "G62.9",
                options: [
                    {
                        Label: "Polyneuropathie bei bösartigem Tumor a.n.k.",
                        Code: "C80.9"
                    },
                    {
                        Label: "Diabetische Polyneuropathie",
                        Code: "E14.40+"
                    },
                    {
                        Label: "Arzneimittelinduzierte Polyneuropathie",
                        Code: "G62.0"
                    },
                    {
                        Label: "Strahlungsinduzierte Polyneuropathie",
                        Code: "G62.88"
                    },
                    {
                        Label: "Komplexes regionales Schmerzsyndrom",
                        Code: "G90.79"
                    }
                ]
            }
        ]
    },
    {
        Label: "Spastik",
        options: [
            {
                Label: "Rigidität der Skelettmuskulatur",
                Code: "R29.8",
                options: [
                    {
                        Label: "Parkinson-Syndrom",
                        Code: "G20"
                    },
                    {
                        Label: "Chronische unbeeinflussbare Schmerzen",
                        Code: "R52.1"
                    }
                ]
            }
        ]
    },
    {
        Label: "Übelkeit und Erbrechen",
        options: [
            {
                Label: "Übelkeit und Erbrechen",
                Code: "R11",
                options: [
                    {
                        Label: "Zytostatische Chemotherapie",
                        Code: "Z92.6"
                    },
                    {
                        Label: "Freitext (Krebserkrankung)"
                    }
                ]
            }
        ]
    },
    {
        Label: "Appetitlosigkeit",
        options: [
            {
                Label: "Appetitverlust",
                Code: "R63.0",
                options: [
                    {
                        Label: "HIV",
                        Code: "B20"
                    },
                    {
                        Label: "Anorexie",
                        Code: "R50.0"
                    },
                    {
                        Label: "Kachexie",
                        Code: "R64"
                    },
                    {
                        Label: "Freitext (Ursache Appetitverlust)"
                    }
                ]
            }
        ]
    },
    {
        Label: "Neurologische Erkrankungen",
        options: [
            {
                Label: "Multiple Sklerose",
                Code: "G35"
            },
            {
                Label: "Tourette-Syndrom",
                Code: "F95.2"
            },
            {
                Label: "Epilepsie",
                Code: "G40"
            },
            {
                Label: "Parkinson",
                Code: "G20"
            },
            {
                Label: "Chronische rheumatische Neuritis",
                Code: "M27.29"
            }
        ]
    },
    {
        Label: "Psychiatrische Erkrankungen",
        options: [
            {
                Label: "Depressionen",
                Code: "F32"
            },
            {
                Label: "Schlafstörungen",
                Code: "F51"
            },
            {
                Label: "Angststörung",
                Code: "F42"
            },
            {
                Label: "Schwere depressive Episode",
                Code: "F32.2"
            },
            {
                Label: "Posttraumatische Belastungsstörung",
                Code: "F43.1"
            },
            {
                Label: "ADHS",
                Code: "F90"
            }
        ]
    },
    {
        Label: "Chronische Erkrankungen",
        options: [
            {
                Label: "Morbus Crohn",
                Code: "K50"
            },
            {
                Label: "Fibromyalgie",
                Code: "M79.7"
            },
            {
                Label: "Chronische rheumatische Neuritis",
                Code: "M27.29"
            }
        ]
    },
    {
        Label: "Palliativbehandlung",
        options: [
            {
                Label: "Palliativbehandlung",
                Code: "Z51.5"
            }
        ]
    }
];

export const QuestOneCenterRadius: CenterRadius[] = [
    {
        Option: "Chronische unbeeinflussbare Schmerzen",
        Center: { THC: 20, CBD: 0.1 },
        Radius: { THC: 50, CBD: 20 }
    },
    {
        Option: "Rigidität der Skelettmuskulatur",
        Center: { THC: 5, CBD: 10 },
        Radius: { THC: 50, CBD: 50 }
    }
];

const _QuestTwoOptions: CannabisOption[] = [
    { Label: "Citalopram (Cipramil®)", Tooltip: "Antidepressivum" },
    { Label: "Sertralin (Zoloft®)", Tooltip: "Antidepressivum" },
    { Label: "Escitalopram (Cipralex®)", Tooltip: "Antidepressivum" },
    { Label: "Amitriptylin (Saroten®/Amineurin®)", Tooltip: "Trizyklische Antidepressiva" },
    { Label: "Venlafaxin (Trevilor®)", Tooltip: "Antidepressivum" },
    { Label: "Duloxetin (Cymbalta®)", Tooltip: "Antidepressivum" },
    { Label: "Methylphenidat (Ritalin®/Medikinet®)", Tooltip: "SNDRI (Selektive Noradrenalin-/Dopamin-Wiederaufnahmehemmer)" },
    { Label: "Atomoxetin (Strattera®)", Tooltip: "ADHS-Medikament" },
    { Label: "Lisdexamfetamin (Elvanse®)", Tooltip: "ADHS-Medikament" },
    { Label: "Diazepam (Valium®/Faustan®)", Tooltip: "Benzodiazepin" },
    { Label: "Midalzolam (Dormicum®)", Tooltip: "Benzodiazepin" },
    { Label: "Chloralhydrat", Tooltip: "Hypnotikum" },
    { Label: "Opipramol", Tooltip: "Trizyklische Antidepressiva" },
    { Label: "Promethazin (Atosil®)", Tooltip: "Neuroleptikum" }
];

export const QuestTwoOptionsDefault = [
    { Label: "Acetylsalicylsäure (ASS®)", Tooltip: "Blutverdünner" },
    { Label: "Pantoprazol (Pantozol®)", Tooltip: "Ulkusprophylaxe" },
    { Label: "Omeprazol (Omep®, Antra MUPS®)", Tooltip: "Ulkusprophylaxe" },
    { Label: "Esomeprazol (Nexium®, Esomep®)", Tooltip: "Ulkusprophylaxe" },
    { Label: "Metoprolol (Beloc-Zok®)", Tooltip: "Blutdrucksenker" },
    { Label: "Ibuprofen", Tooltip: "Analgetikum" },
    { Label: "Levothyroxin (L-Thyrox@)", Tooltip: "Schiddrüsenhormon" },
    { Label: "Metamizol (Novalgin@)", Tooltip: "Analgetikum" },
    { Label: "Diclofenac", Tooltip: "Analgetikum" },
    { Label: "Tilidin/Naloxon", Tooltip: "Analgetikum" },
    { Label: "Tramadol", Tooltip: "Analgetikum" },
    { Label: "Paracetamol", Tooltip: "Analgetikum" },
    { Label: "Pregabalin (Lyrica®)", Tooltip: "Analgetikum" },
    { Label: "Levodopa/Benserazid", Tooltip: "Anti-Parkinson-Mittel" },
    { Label: "Citalopram", Tooltip: "Antidepressivum" },
    { Label: "Mirtazapin", Tooltip: "Antidepressivum" },
    { Label: "Opipramol", Tooltip: "Antidepressivum" },
    { Label: "Metformin", Tooltip: "Antidiabetikum" },
    { Label: "Metoclopramid (MCP®)", Tooltip: "Antiemetikum" },
    { Label: "Ramipril (Delix®)", Tooltip: "Blutdrucksenker" },
    { Label: "Bisoprolol (Concor®)", Tooltip: "Blutdrucksenker" },
    { Label: "Amlodipin", Tooltip: "Blutdrucksenker" },
    { Label: "Enalapril", Tooltip: "Blutdrucksenker" },
    { Label: "Candesartan", Tooltip: "Blutdrucksenker" },
    { Label: "Valsartan", Tooltip: "Blutdrucksenker" },
    { Label: "Lisinopril", Tooltip: "Blutdrucksenker" },
    { Label: "Moxonidin", Tooltip: "Blutdrucksenker" },
    { Label: "Phenprocoumon (Marcumar)", Tooltip: "Blutverdünner" },
    { Label: "Salbutamol", Tooltip: "Bronchodilatator" },
    { Label: "Simvastatin", Tooltip: "Cholesterinsenker" },
    { Label: "Atorvastatin", Tooltip: "Cholesterinsenker" },
    { Label: "Torasemid (Torem®)", Tooltip: "Diuretikum" },
    { Label: "Furosemid (Lasix®)", Tooltip: "Diuretikum" },
    { Label: "Hydrochlorthiazid (HCT®)", Tooltip: "Diuretikum" },
    { Label: "Allupurinol", Tooltip: "Gichtmittel" },
    { Label: "Insulin", Tooltip: "Insulin" },
    { Label: "Predenisolon", Tooltip: "Kortison" },
    { Label: "Budesonid", Tooltip: "Kortison" },
    { Label: "Tamsulosin", Tooltip: "Prostatamittel" },
    { Label: "Zopiclon", Tooltip: "Schlafmittel" },
    { Label: etwasAnderes, Tooltip: etwasAnderes }
];

export const fnQuestTwoOptions = (options) => {
    switch (true) {
        case options.indexOf("Migräne") > -1:
            return [
                { Label: "Acetylsalicylsäure (ASS/Aspirin®)", Tooltip: "Nichtopioid-Analgetikum" },
                { Label: "Ibuprofen (Ibuprofen/Dolormin®/Nurofen®)", Tooltip: "Nichtopioid-Analgetikum" },
                { Label: "Diclofenac (Diclofenac/Diclac®/Voltaren®)", Tooltip: "Nichtopioid-Analgetikum" },
                { Label: "ASS+Paracetamol+Koffein (Thomapyrin®)", Tooltip: "Kombinationspräparate" },
                { Label: "Metamizol (Novalgin®/Novaminsulfon®)", Tooltip: "Nichtopioid-Analgetikum" },
                { Label: "Sumatriptan (Imigran®)", Tooltip: "Triptane" },
                { Label: "Almotriptan (Almogran®)", Tooltip: "Triptane" },
                { Label: "Zolmitriptan (Zomig®)", Tooltip: "Triptane" },
                { Label: "Naratriptan (Formigran®)", Tooltip: "Triptane" },
                { Label: "Rizatriptan (Maxalt®)", Tooltip: "Triptane" },
                { Label: "Eletriptan (Relpax®)", Tooltip: "Triptane" },
                { Label: "Tramadol (Tramal®)", Tooltip: "Opioide" },
                { Label: "Tilidin/Naloxon (Valoron®)", Tooltip: "Opioide" },
                { Label: "Oxycodon +Naloxon (Oxygesic®/Targin®)", Tooltip: "Opioide" },
                { Label: "Ergotamintartrat (Ergo-Kranit®)", Tooltip: "Ergotamine" },
                { Label: "Metoprolol (Beloc-ZOK®/Beloc®/Lopresor®)", Tooltip: "Migräneprophylaxe (Betablocker)" },
                { Label: "Bisoprolol (Concor®)", Tooltip: "Migräneprophylaxe (Betablocker)" },
                { Label: "Amitriptylin (Saroten®/Amineurin®)", Tooltip: "Migräneprophylaxe (Antidepressivum)" },
                { Label: "Valproinsäure (Valproat®/Ergenyl®/Convulex®/Orfiril®)", Tooltip: "Migräneprophylaxe (Antiepileptikun)" },
                { Label: "Erenumab (Aimovig®)", Tooltip: "Migräneprophylaxe (CGRP-Antikörper)" },
                { Label: "Fremanezumab (Ajovy®)", Tooltip: "Migräneprophylaxe (CGRP-Antikörper)" },
                { Label: "Galcanezumab (Emgality®)", Tooltip: "Migräneprophylaxe (CGRP-Antikörper)" },
            ];
        case (options.indexOf("Schmerz") > -1 || options.indexOf("Chronische unbeeinflussbare Schmerzen") > -1 || options.indexOf("Chronisches Schmerzsyndrom") > -1 || options.indexOf("Tumorschmerz") > -1 || options.indexOf("Chronische rheumatische Neuritis") > -1 || options.indexOf("Fibromyalgie") > -1):
            return [
                { Label: "Metamizol (Novalgin®/Novaminsulfon®)", Tooltip: "Nichtopioid-Analgetikum" },
                { Label: "Ibuprofen", Tooltip: "Nichtopioid-Analgetikum" },
                { Label: "Paracetamol", Tooltip: "Nichtopioid-Analgetikum" },
                { Label: "Diclofenac (Voltaren®/Diclac®)", Tooltip: "Nichtopioid-Analgetikum" },
                { Label: "Parecoxib (Dynastat®)", Tooltip: "Nichtopioid-Analgetikum" },
                { Label: "Celecoxib (Celebrex®)", Tooltip: "Nichtopioid-Analgetikum" },
                { Label: "Tramadol (Tramal®)", Tooltip: "Opioide" },
                { Label: "Tilidin/Naloxon (Valoron®)", Tooltip: "Opioide" },
                { Label: "Codein", Tooltip: "Opioide" },
                { Label: "Oxycodon (+Naloxon) (Oxygesic®/Targin®)", Tooltip: "Opioide" },
                { Label: "Morphin (Capros®/MSI®)", Tooltip: "Opioide" },
                { Label: "Methadon (L-)Polamidon®", Tooltip: "Opioide" },
                { Label: "Schmerzpflaster mit Fentanyl (Durogesic®, Actic®, Effentora®)", Tooltip: "Opioide" },
                { Label: "Schmerzpflaster mit Buprenorphin (Norspan®, Temgesic®, Transtec®)", Tooltip: "Opioide" },
                { Label: "Hydromorphon (Palladon®, Jurnista®)", Tooltip: "Opioide" },
                { Label: "Buprenorphin (Subutex®)", Tooltip: "Opioide" },
                { Label: "Pregabalin (Lyrica®)", Tooltip: "Co-Analgetika" },
                { Label: "Amitriptylin (Saroten®/Amineurin®)", Tooltip: "Co-Analgetika" },
                { Label: "Baclofen (Lebic®, Lioresal®)", Tooltip: "Co-Analgetika" },
                { Label: "Ketamin", Tooltip: "Co-Analgetika" },
                { Label: "Gabapentin", Tooltip: "Co-Analgetika" },
                { Label: "Carbamazepin (Timonil®)", Tooltip: "Co-Analgetika" },
                { Label: "Dexamethason (Fortecortin®)", Tooltip: "Co-Analgetika" }
            ];
        case (options.indexOf("Spastik") > -1 || options.indexOf("Parkinson") > -1):
            return [
                { Label: "Levodopa/Benserazid (Levodopa comp®, Levopar®, Madopar®, Restex®)", Tooltip: "Anti-Parkinson-Mittel (L-DOPA+Decarboxylasehemmer)" },
                { Label: "Levodopa/Carbidopa (Isicom®/Nacom®)", Tooltip: "Anti-Parkinson-Mittel (L-DOPA+Decarboxylasehemmer)" },
                { Label: "Bromocriptin (Pravidel®)", Tooltip: "Anti-Parkinson-Mittel (Ergot-Dopaminagonist)" },
                { Label: "Pergolid (Parkotil®)", Tooltip: "Anti-Parkinson-Mittel (Ergot-Dopaminagonist)" },
                { Label: "Dihydroergocryptin (Almirid®/Cripar®)", Tooltip: "Anti-Parkinson-Mittel (Dopamin-D2-Agonist)" },
                { Label: "Cabergolin (Cabaseril®)", Tooltip: "Anti-Parkinson-Mittel (Dopamin-D2-Agonist)" },
                { Label: "Lisurid (Dopergin®)", Tooltip: "Anti-Parkinson-Mittel (Dopaminagonist)" },
                { Label: "Pramipexol (Sifrol®)", Tooltip: "Anti-Parkinson-Mittel (Non-Ergot-Dopaminagonist)" },
                { Label: "Ropinirol (Adartrel®, Requip®, Ralnea®)", Tooltip: "Anti-Parkinson-Mittel (Non-Ergot-Dopaminagonist)" },
                { Label: "Entacapon (Comtess®)", Tooltip: "Anti-Parkinson-Mittel (COMT-Hemmer)" },
                { Label: "Selegilin (Antiparkin®/Jutagilin®/Movergan®)", Tooltip: "Anti-Parkinson-Mittel (MAO-B-Hemmer)" },
                { Label: "Rasagilin (Azilect®)", Tooltip: "Anti-Parkinson-Mittel (MAO-B-Hemmer)" },
                { Label: "Amantadin (PK-Merz®)", Tooltip: "Anti-Parkinson-Mittel (NMDA-Antagonist)" },
                { Label: "Biperidin (Akineton®)", Tooltip: "Anti-Parkinson-Mittel (Anticholinergika)" },
                { Label: "L-Dopa, Carbidopa und Entacapon (Stalevo®)", Tooltip: "Anti-Parkinson-Mittel (L-DOPA+Decarboxylasehemmer+COMT-Hemmer)" }
            ];
        case options.indexOf("Übelkeit und Erbrechen") > -1:
            return [
                { Label: "Ondansetron (Zofran®)", Tooltip: "Serotonin-Rezeptor-Antagonisten" },
                { Label: "Granisetron (Kytril®)", Tooltip: "Serotonin-Rezeptor-Antagonisten" },
                { Label: "Aprepitant (Emend®)", Tooltip: "Neurokinin-Rezeptor-Antagonisten" },
                { Label: "Fosaprepitant (Ivemend®)", Tooltip: "Neurokinin-Rezeptor-Antagonisten" },
                { Label: "Netupitant (Akynzeo®)", Tooltip: "Neurokinin-Rezeptor-Antagonisten" },
                { Label: "Rolapitant (Varubi®)", Tooltip: "Neurokinin-Rezeptor-Antagonisten" },
                { Label: "Dexamethason (Fortecortin®)", Tooltip: "Kortison" },
                { Label: "Prednisolon (Decortin®, Solu-Decortin®)", Tooltip: "Kortison" },
                { Label: "Metoclopramid (Paspertin®, MCP®)", Tooltip: "Dopaminantagonisten" },
                { Label: "Domperidon (Motilium®)", Tooltip: "Dopaminantagonisten" },
                { Label: "Midazolam (Dormicum®)", Tooltip: "Benzodiazepine" },
                { Label: "Diazepam (Valium®, Stesolid®)", Tooltip: "Benzodiazepine" },
                { Label: "Alprazolam (Xanax®)", Tooltip: "Benzodiazepine" },
                { Label: "Oxazepam (Seresta®, Anxiolit®)", Tooltip: "Benzodiazepine" },
                { Label: "Olanzapin (Zyprexa®)", Tooltip: "Neuroleptika" },
                { Label: "Dimenhydrinat (Vomex®)", Tooltip: "Antihistaminika" }
            ];
        case options.indexOf("Appetitlosigkeit") > -1:
            return [
                { Label: "Metoclopramid (Paspertin®, MCP®)", Tooltip: "Dopaminantagonisten" },
                { Label: "Domperidon (Motilium®)", Tooltip: "Dopaminantagonisten" },
                { Label: "Dexamethason (Fortecortin®)", Tooltip: "Kortison" },
                { Label: "Prednisolon (Decortin®, Solu-Decortin®)", Tooltip: "Kortison" },
                { Label: "Mirtazapin", Tooltip: "Antidepressiva" },
                { Label: "Medroxyprogesteron (Remergil®)", Tooltip: "Gestagene" },
                { Label: "Megestrolacetat (Megace ES®)", Tooltip: "Gestagene" }
            ];
        case options.indexOf("Multiple Sklerose") > -1:
            return [
                { Label: "Methylprednisolon (Urbason®)", Tooltip: "Schubtherapie" },
                { Label: "Beta-Interferone (Avonex®/Betaferon®/Extavia®/Rebif®)", Tooltip: "Basistherapie" },
                { Label: "Fumarsäuredimethylester (Tecfidera®)", Tooltip: "Basistherapie" },
                { Label: "Glatirameracetat (Copaxone®)", Tooltip: "Basistherapie" },
                { Label: "Azathioprin (Imurek®/Azafalk®)", Tooltip: "Basistherapie" },
                { Label: "Immunglobuline (Gamunex®/Octagam®)", Tooltip: "Immunglobulin-Therapie" },
                { Label: "Alemtuzumab (Lemtrada®)", Tooltip: "Eskalationstherapie" },
                { Label: "Fingolimod (Gilenya®)", Tooltip: "Eskalationstherapie" },
                { Label: "Natalizumab (Tysabri®)", Tooltip: "Eskalationstherapie" },
                { Label: "Ocrelizumab (Ocrevus®)", Tooltip: "Eskalationstherapie" }
            ];
        case options.indexOf("Tourette-Syndrom") > -1:
            return [
                { Label: "Tiaprid (Delpral®)", Tooltip: "Antihyperkinetikum" },
                { Label: "Sulpirid (Arminol®/Dogmatil®/Meresa®)", Tooltip: "Atypische Neuroleptika" },
                { Label: "Risperidon (Risperdal®)", Tooltip: "Atypische Neuroleptika" },
                { Label: "Pimozid (Orap®) ", Tooltip: "Neuroleptikum" },
                { Label: "Aripiprazol (Abilify®)", Tooltip: "Atypische Neuroleptika" }
            ];
        case options.indexOf("Epilepsie") > -1:
            return [
                { Label: "Carbamazepin (Timonil®)", Tooltip: "Antiepileptikun" },
                { Label: "Valproinsäure (Valproat®/Ergenyl®/Convulex®/Orfiril®)", Tooltip: "Antiepileptikun" },
                { Label: "Lamotrigin", Tooltip: "Antiepileptikun" },
                { Label: "Levetiracetam (Keppra®)", Tooltip: "Antiepileptikun" }
            ];
        case options.indexOf("Morbus Crohn") > -1:
            return [
                { Label: "Budesonid (Budenofalk®, Entocort®)", Tooltip: "Glukokortikoide" },
                { Label: "Prednisolon (Decortin®, Solu-Decortin®)", Tooltip: "Glukokortikoide" },
                { Label: "Dexamethason (Fortecortin®)", Tooltip: "Glukokortikoide" },
                { Label: "Mesalazin (Salofalk®, Pentasa®)", Tooltip: "Antiphlogistika" },
                { Label: "Sulfasalazin (Salazopyrin®)", Tooltip: "Antiphlogistika" },
                { Label: "Azathioprin (Imurek®, Azafalk®)", Tooltip: "Immunsuppressiva" },
                { Label: "Infliximab (Remicade®)", Tooltip: "Immunsuppressiva" },
                { Label: "Methotrexat (Bendatrexat®, MXT, Metex®)", Tooltip: "Zytostatika" },
                { Label: "Mercaptopurin (INN, Purinethol®)", Tooltip: "Zytostatika" },
                { Label: "Vedolizumab (Entyvio®)", Tooltip: "Monoklonale Antikörper" },
                { Label: "Adalimumab (Humira®)", Tooltip: "Monoklonale Antikörper" }
            ];
        case (options.indexOf("Schlafstörungen") > -1 || options.indexOf("ADHS") > -1):
            return _QuestTwoOptions;
        case options.indexOf("Posttraumatische Belastungsstörung") > -1:
            return [
                { Label: "Citalopram (Cipramil®)", Tooltip: "SSRI (Selektive Serotonin-Wiederaufnahmehemmer)" },
                { Label: "Sertralin (Zoloft®)", Tooltip: "SSRI (Selektive Serotonin-Wiederaufnahmehemmer)" },
                { Label: "Escitalopram (Cipralex®)", Tooltip: "SSRI (Selektive Serotonin-Wiederaufnahmehemmer)" },
                { Label: "Paroxetin (Paroxalon®, Paroxat®, Seroxat®)", Tooltip: "SSRI (Selektive Serotonin-Wiederaufnahmehemmer)" },
                { Label: "Venlafaxin (Trevilor®)", Tooltip: "SSNRI (Serotonin-Noradrenalin-Wiederaufnahmehemmer)" },
                { Label: "Duloxetin (Cymbalta®)", Tooltip: "SSNRI (Serotonin-Noradrenalin-Wiederaufnahmehemmer)" },
                { Label: "Diazepam (Valium®/Faustan®)", Tooltip: "Benzodiazepin" },
                { Label: "Midalzolam (Dormicum®)", Tooltip: "Benzodiazepin" },
                { Label: "Lorazepam (Tavor®)", Tooltip: "Benzodiazepin" }
            ];
        case (options.indexOf("Depressionen") > -1 || options.indexOf("Schwere depressive Episode") > -1):
            return [
                { Label: "Citalopram (Cipramil®)", Tooltip: "SSRI (Selektive Serotonin-Wiederaufnahmehemmer)" },
                { Label: "Sertralin (Zoloft®)", Tooltip: "SSRI (Selektive Serotonin-Wiederaufnahmehemmer)" },
                { Label: "Escitalopram (Cipralex®)", Tooltip: "SSRI (Selektive Serotonin-Wiederaufnahmehemmer)" },
                { Label: "Venlafaxin (Trevilor®)", Tooltip: "SSNRI (Serotonin-Noradrenalin-Wiederaufnahmehemmer)" },
                { Label: "Duloxetin (Cymbalta®)", Tooltip: "SSNRI (Serotonin-Noradrenalin-Wiederaufnahmehemmer)" },
                { Label: "Reboxetin (Edronax®, Solvex®)", Tooltip: "SNRI (Selektive Noradrenalin-Wiederaufnahmehemmer)" },
                { Label: "Amitriptylin (Saroten®/Amineurin®)", Tooltip: "Trizyklische Antidepressiva" },
                { Label: "Opipramol (Insidon®)", Tooltip: "Trizyklische Antidepressiva" },
                { Label: "Diazepam (Valium®/Faustan®)", Tooltip: "Benzodiazepin" },
                { Label: "Midalzolam (Dormicum®)", Tooltip: "Benzodiazepin" },
                { Label: "Chloralhydrat", Tooltip: "Hypnotikum" },
                { Label: "Promethazin (Atosil®)", Tooltip: "Neuroleptikum" },
                { Label: "Lithium (Hypnorex®)", Tooltip: "Lithium" },
                { Label: "Mirtazapin (Remergil®, Quilonum®)", Tooltip: "Tetrazyklische Antidepressiva" }
            ];
        case (options.indexOf("Angststörung") > -1):
            return [
                { Label: "Citalopram (Cipramil®)", Tooltip: "SSRI (Selektive Serotonin-Wiederaufnahmehemmer)" },
                { Label: "Sertralin (Zoloft®)", Tooltip: "SSRI (Selektive Serotonin-Wiederaufnahmehemmer)" },
                { Label: "Escitalopram (Cipralex®)", Tooltip: "SSRI (Selektive Serotonin-Wiederaufnahmehemmer)" },
                { Label: "Venlafaxin (Trevilor®)", Tooltip: "SSNRI (Serotonin-Noradrenalin-Wiederaufnahmehemmer)" },
                { Label: "Duloxetin (Cymbalta®)", Tooltip: "SSNRI (Serotonin-Noradrenalin-Wiederaufnahmehemmer)" },
                { Label: "Reboxetin (Edronax®, Solvex®)", Tooltip: "SNRI (Selektive Noradrenalin-Wiederaufnahmehemmer)" },
                { Label: "Amitriptylin (Saroten®/Amineurin®)", Tooltip: "Trizyklische Antidepressiva" },
                { Label: "Opipramol (Insidon®)", Tooltip: "Trizyklische Antidepressiva" },
                { Label: "Diazepam (Valium®/Faustan®)", Tooltip: "Benzodiazepin" },
                { Label: "Midalzolam (Dormicum®)", Tooltip: "Benzodiazepin" },
                { Label: "Lorazepam (Tavor®)", Tooltip: "Benzodiazepin" },
                { Label: "Imipramin (Tofranil®)", Tooltip: "Tetrazyklische Antidepressiva" },
                { Label: "Buspiron (Anxut®, Busp®, Bespar®)", Tooltip: "Anxiolytikum (selektiver Serotoninagonist)" }
            ];
        default:
            return [];
    }
}

export const QuestTwoOptions: CannabisOptionNested[] = [
    {
        Label: "Migräne",
        options: fnQuestTwoOptions(["Migräne"])
    },
    {
        Label: "Schmerz",
        options: fnQuestTwoOptions(["Schmerz"])
    },
    {
        Label: "Spastik",
        options: fnQuestTwoOptions(["Spastik"])
    },
    {
        Label: "Übelkeit und Erbrechen",
        options: fnQuestTwoOptions(["Übelkeit und Erbrechen"])
    },
    {
        Label: "Appetitlosigkeit",
        options: fnQuestTwoOptions(["Appetitlosigkeit"])
    },
    {
        Label: "Multiple Sklerose",
        options: fnQuestTwoOptions(["Multiple Sklerose"])
    },
    {
        Label: "Tourette-Syndrom",
        options: fnQuestTwoOptions(["Tourette-Syndrom"])
    },
    {
        Label: "Epilepsie",
        options: fnQuestTwoOptions(["Epilepsie"])
    },
    {
        Label: "Depressionen",
        options: _QuestTwoOptions
    },
    {
        Label: "Schlafstörungen",
        options: _QuestTwoOptions
    },
    {
        Label: "ADHS",
        options: _QuestTwoOptions
    },
    {
        Label: "DEFAULT",
        options: QuestTwoOptionsDefault
    }
];

export const QuestThreePositiveOptions = (options) => {
    switch (true) {
        case options.indexOf("Migräne") > -1:
            return [
                { Label: "Weniger Kopfschmerzen" },
                { Label: "Geringere Anzahl von Migräneanfällen" },
                { Label: "Weniger Angst" },
                { Label: "Besserer Schlaf" },
                { Label: "Verbessertes Allgemeinbefinden" },
                { Label: etwasAnderes }
            ];
        case (options.indexOf("Schmerz") > -1 || options.indexOf("Chronische unbeeinflussbare Schmerzen") > -1 || options.indexOf("Chronische rheumatische Neuritis") > -1 || options.indexOf("Fibromyalgie") > -1):
            return [
                { Label: "Weniger Schmerzen" },
                { Label: "Weniger Angst" },
                { Label: "Besserer Schlaf" },
                { Label: "Verbessertes Allgemeinbefinden" },
                { Label: etwasAnderes }
            ];
        case (options.indexOf("Spastik") > -1 || options.indexOf("Parkinson") > -1):
            return [
                { Label: "Weniger Rigor" },
                { Label: "Weniger Tremor" },
                { Label: "Weniger depressive Stimmung" },
                { Label: "Besserer Schlaf" },
                { Label: "Verbessertes Allgemeinbefinden" },
                { Label: etwasAnderes }
            ];
        case options.indexOf("Übelkeit und Erbrechen") > -1:
            return [
                { Label: "Weniger Übelkeit" },
                { Label: "Weniger Erbrechen" },
                { Label: "Besserer Schlaf" },
                { Label: "Verbessertes Allgemeinbefinden" },
                { Label: etwasAnderes }
            ];
        case options.indexOf("Appetitlosigkeit") > -1:
            return [
                { Label: "Mehr Appetit" },
                { Label: "Gewichtszunahme" },
                { Label: "Besserer Schlaf" },
                { Label: "Verbessertes Allgemeinbefinden" },
                { Label: etwasAnderes }
            ];
        case options.indexOf("Multiple Sklerose") > -1:
            return [
                { Label: "Reduktion der Schübe" },
                { Label: "Symptombesserung" },
                { Label: "Verbessertes Allgemeinbefinden" },
                { Label: "Muskelentspannend" },
                { Label: "Schmerzlindernd" },
                { Label: etwasAnderes }
            ];
        case options.indexOf("Tourette-Syndrom") > -1:
            return [
                { Label: "Reduktion der Anfallshäufigkeit" },
                { Label: "Reduktion der Anfallsstärke" },
                { Label: "Verbessertes Allgemeinbefinden" },
                { Label: etwasAnderes }
            ];
        case options.indexOf("Epilepsie") > -1:
            return [
                { Label: "Reduktion der Anfallshäufigkeit" },
                { Label: "Gestärktes Sicherheitsgefühl" },
                { Label: "Verbessertes Allgemeinbefinden" },
                { Label: etwasAnderes }
            ];
        case options.indexOf("Morbus Crohn") > -1:
            return [
                { Label: "Weniger Diarrhoe" },
                { Label: "Weniger Bauchschmerzen" },
                { Label: "Fisteln in Remission" },
                { Label: "Besserer Schlaf" },
                { Label: "Verbessertes Allgemeinbefinden" },
                { Label: etwasAnderes }
            ];
        case (options.indexOf("Schlafstörungen") > -1 || options.indexOf("ADHS") > -1 || options.indexOf("Posttraumatische Belastungsstörung") > -1):
            return [
                { Label: "Verbesserte Stimmung" },
                { Label: "Besserer Schlaf" },
                { Label: "Verbessertes Allgemeinbefinden" },
                { Label: etwasAnderes }
            ];
        case (options.indexOf("Depressionen") > -1 || options.indexOf("Schwere depressive Episode") > -1):
            return [
                { Label: "Verbesserte Stimmung" },
                { Label: "Besserer Schlaf" },
                { Label: "Verbessertes Allgemeinbefinden" },
                { Label: etwasAnderes }
            ];
        case (options.indexOf("Angststörung") > -1):
            return [
                { Label: "Weniger Angst" },
                { Label: "Weniger Panikattacken" },
                { Label: "Besserer Schlaf" },
                { Label: "Verbessertes Allgemeinbefinden" },
                { Label: etwasAnderes }
            ];
        default:
            return [
                { Label: "Verbessertes Allgemeinbefinden" },
                { Label: "Steigerung der Libido" },
                { Label: "Weniger Schmerzen" },
                { Label: "Weniger Schlaflosigkeit" },
                { Label: "Gewichtszunahme" },
                { Label: "Gewichtsabnahme" },
                { Label: "Weniger Anfälle" },
                { Label: "Mehr Lebensfreude" },
                { Label: etwasAnderes }
            ];
    }
}

export const QuestThreeNegativeOptions = (options) => {
    switch (true) {
        case (options.indexOf("Schmerz") > -1 || options.indexOf("Chronische unbeeinflussbare Schmerzen") > -1 || options.indexOf("Chronische rheumatische Neuritis") > -1 || options.indexOf("Fibromyalgie") > -1):
            return [
                { Label: "Müdigkeit" },
                { Label: "Erschöpfung" },
                { Label: "Verstopfungen" },
                { Label: "Probleme beim Wasserlassen" },
                { Label: "Verlust der Libido" },
                { Label: "Appetitlosigkeit" },
                { Label: "Traurigkeit" },
                { Label: "Gewichtszunahme" },
                { Label: "Schmerzen lassen sich nicht mehr behandeln" },
                { Label: "Eine weitere Steigerung der Dosierung dieses Medikaments ist nicht mehr möglich" },
                { Label: etwasAnderes }
            ];
        case (options.indexOf("Spastik") > -1 || options.indexOf("Parkinson") > -1):
            return [
                { Label: "Müdigkeit" },
                { Label: "Erschöpfung" },
                { Label: "Probleme beim Wasserlassen" },
                { Label: "Verlust der Libido" },
                { Label: "Appetitlosigkeit" },
                { Label: "Traurigkeit" },
                { Label: "Gewichtszunahme" },
                { Label: "Eine weitere Steigerung der Dosierung dieses Medikaments ist nicht mehr möglich" },
                { Label: etwasAnderes }
            ];
        case options.indexOf("Übelkeit und Erbrechen") > -1:
            return [
                { Label: "Müdigkeit" },
                { Label: "Erschöpfung" },
                { Label: "Appetitlosigkeit" },
                { Label: "Gewichtszunahme" },
                { Label: "Übelkeit fortbestehend" },
                { Label: "Erbrechen fortbestehend" },
                { Label: "Wärmegefühl" },
                { Label: "Kopfschmerzen, Schwindel" },
                { Label: "Verstopfung, Durchfall" },
                { Label: "Niedriger Blutdruck" },
                { Label: "Eine weitere Steigerung der Dosierung dieses Medikaments ist nicht mehr möglich" },
                { Label: etwasAnderes }
            ];
        case options.indexOf("Appetitlosigkeit") > -1:
            return [
                { Label: "Keine Wirkung (kein Appetit)" },
                { Label: "Müdigkeit" },
                { Label: "Gewichtsabnahme" },
                { Label: "Eine weitere Steigerung der Dosierung dieses Medikaments ist nicht mehr möglich" },
                { Label: etwasAnderes }
            ];
        case options.indexOf("Multiple Sklerose") > -1:
            return [
                { Label: "Keine Wirkung mehr (mehr Spastik)" },
                { Label: "Keine Wirkung mehr (mehr Schmerzen)" },
                { Label: "Müdigkeit" },
                { Label: "Gewichtsabnahme" },
                { Label: "Gewichtszunahme" },
                { Label: "Erschöpfung" },
                { Label: "Verstopfungen" },
                { Label: "Probleme beim Wasserlassen" },
                { Label: "Verlust der Libido" },
                { Label: "Appetitlosigkeit" },
                { Label: "Traurigkeit" },
                { Label: "Eine weitere Steigerung der Dosierung dieses Medikaments ist nicht mehr möglich" },
                { Label: etwasAnderes }
            ];
        case options.indexOf("Tourette-Syndrom") > -1:
            return [
                { Label: "Keine Wirkung mehr (mehr Anfälle)" },
                { Label: "Keine Wirkung mehr (mehr Schmerzen)" },
                { Label: "Müdigkeit" },
                { Label: "Gewichtsabnahme" },
                { Label: "Gewichtszunahme" },
                { Label: "Erschöpfung" },
                { Label: "Verstopfungen" },
                { Label: "Probleme beim Wasserlassen" },
                { Label: "Verlust der Libido" },
                { Label: "Appetitlosigkeit" },
                { Label: "Traurigkeit" },
                { Label: "Eine weitere Steigerung der Dosierung dieses Medikaments ist nicht mehr möglich" },
                { Label: etwasAnderes }
            ];
        case options.indexOf("Epilepsie") > -1:
            return [
                { Label: "Anfallhäufigkeit vermehrt" },
                { Label: "Keine Wirkung mehr (mehr Schmerzen)" },
                { Label: "Müdigkeit und Erschöpfung" },
                { Label: "Ataxie" },
                { Label: "Leukopenie" },
                { Label: "Deutliche Gamma-GT Erhöhung" },
                { Label: "Tremor" },
                { Label: "Hyperammonämie" },
                { Label: "Eine weitere Steigerung der Dosierung dieses Medikaments ist nicht mehr möglich" },
                { Label: etwasAnderes }
            ];
        case options.indexOf("Morbus Crohn") > -1:
            return [
                { Label: "Diarrhoen persistierend" },
                { Label: "Fisteln rezidivierend und persistierend" },
                { Label: "Operationen konnten nicht verhindert werden" },
                { Label: "Persistierende Schmerzen" },
                { Label: "Malabsorption gravierend" },
                { Label: "Müdigkeit und Erschöpfung" },
                { Label: "Gewichtszunahme" },
                { Label: "Libidoverlust" },
                { Label: etwasAnderes }
            ];
        case (options.indexOf("Schlafstörungen") > -1 || options.indexOf("ADHS") > -1 || options.indexOf("Posttraumatische Belastungsstörung") > -1):
            return [
                { Label: "Depressive Stimmung persistierend" },
                { Label: "Negative Emotionen überwiegen" },
                { Label: "Müdigkeit und Erschöpfung" },
                { Label: "Gewichtszunahme" },
                { Label: "Libidoverlust" },
                { Label: "Extreme Stimmungsschwankungen" },
                { Label: "Selbstverletzendes Verhalten persistierend" },
                { Label: "Emotionaler Kontrollverlust" },
                { Label: "Eine weitere Steigerung der Dosierung dieses Medikaments ist nicht mehr möglich" },
                { Label: etwasAnderes }
            ];
        case (options.indexOf("Depressionen") > -1 || options.indexOf("Schwere depressive Episode")):
            return [
                { Label: "Depressive Stimmung persistierend" },
                { Label: "Negative Emotionen überwiegen" },
                { Label: "Müdigkeit und Erschöpfung" },
                { Label: "Gewichtszunahme" },
                { Label: "Libidoverlust" },
                { Label: "Extreme Stimmungsschwankungen" },
                { Label: "Selbstverletzendes Verhalten persistierend" },
                { Label: "Emotionaler Kontrollverlust" },
                { Label: "Eine weitere Steigerung der Dosierung dieses Medikaments ist nicht mehr möglich" },
                { Label: etwasAnderes }
            ];
        case (options.indexOf("Angststörung") > -1):
            return [
                { Label: "Nervösität und Unruhe persistierend" },
                { Label: "Andauernde Schreckhaftigkeitpersistiert" },
                { Label: "Depressive Episoden" },
                { Label: "Weiterhin Panikattacken" },
                { Label: "Libidoverlust" },
                { Label: "Extreme Stimmungsschwankungen" },
                { Label: "Müdigkeit und Erschöpfung" },
                { Label: "Gewichtszunahme" },
                { Label: "Eine weitere Steigerung der Dosierung dieses Medikaments ist nicht mehr möglich" },
                { Label: etwasAnderes }
            ];
        default:
            return [
                { Label: "Müdigkeit" },
                { Label: "Schlaflosigkeit" },
                { Label: "Gewichtsabnahme" },
                { Label: "Gewichtszunahme" },
                { Label: "Libido-Verlust" },
                { Label: "Progrediente Leberinsuffizienz" },
                { Label: "Progrediente Niereninsuffizienz" },
                { Label: "Kreislaufschwäche" },
                { Label: "Blutbildveränderungen" },
                { Label: "Eine weitere Steigerung der Dosierung dieses Medikaments ist nicht mehr möglich" },
                { Label: etwasAnderes }
            ];
    }
}

export const QuestElevenOptions = (options) => {
    switch (true) {
        case (options.indexOf("Schmerz") > -1 || options.indexOf("Chronische unbeeinflussbare Schmerzen") > -1 || options.indexOf("Chronische rheumatische Neuritis") > -1 || options.indexOf("Fibromyalgie") > -1):
            return [
                { Label: "Positive Beeinflussung des Schmerzgedächtnisses um ein „Relearning“ (Umprogrammierung des Schmerzgedächtnisses zu erreichen)" },
                { Label: "Vermeidung von Krankenhausaufenthalten" },
                { Label: "Reduktion bzw. Vermeidung der starken und die Lebensqualität reduzierenden Nebenwirkungen der bisherigen Medikation" },
                { Label: "Reduktion von Medikamenten" },
                { Label: "Reduktion bzw. Vermeidung von Sturzgefahr" },
                { Label: "Erhalt bzw. Wiederherstellung der Selbstversorgung im häuslichen Milieu" },
                { Label: "Multisymptomatischer Therapieansatz (Reduktion von Schmerzen und Angst, Stresssenkung, Regulation von Muskeltonus und Appetit)" },
                { Label: "Erhöhung der Lebensqualität!" },
                { Label: etwasAnderes }
            ];
        case (options.indexOf("Spastik") > -1 || options.indexOf("Parkinson") > -1):
            return [
                { Label: "Vermeidung von Krankenhausaufenthalten" },
                { Label: "Reduktion bzw. Vermeidung der starken und die Lebensqualität reduzierenden Nebenwirkungen der bisherigen Medikation" },
                { Label: "Reduktion von Medikamenten" },
                { Label: "Reduktion bzw. Vermeidung von Sturzgefahr" },
                { Label: "Erhalt bzw. Wiederherstellung der Selbstversorgung im häuslichen Milieu" },
                { Label: "Multisymptomatischer Therapieansatz (Reduktion von Schmerzen und Angst, Stresssenkung, Regulation von Muskeltonus und Appetit)" },
                { Label: "Erhöhung der Lebensqualität!" },
                { Label: etwasAnderes }
            ];
        case options.indexOf("Übelkeit und Erbrechen") > -1:
            return [
                { Label: "Vermeidung von Krankenhausaufenthalten" },
                { Label: "Reduktion bzw. Vermeidung der starken und die Lebensqualität reduzierenden Nebenwirkungen der bisherigen Medikation" },
                { Label: "Reduktion von Medikamenten" },
                { Label: "Reduktion bzw. Vermeidung von Sturzgefahr" },
                { Label: "Erhalt bzw. Wiederherstellung der Selbstversorgung im häuslichen Milieu" },
                { Label: "Multisymptomatischer Therapieansatz (Reduktion von Schmerzen und Angst, Stresssenkung, Regulation von Muskeltonus und Appetit)" },
                { Label: "Erhöhung der Lebensqualität!" },
                { Label: etwasAnderes }
            ];
        case options.indexOf("Appetitlosigkeit") > -1:
            return [
                { Label: "Vermeidung von Krankenhausaufenthalten" },
                { Label: "Reduktion bzw. Vermeidung der starken und die Lebensqualität reduzierenden Nebenwirkungen der bisherigen Medikation" },
                { Label: "Reduktion von Medikamenten" },
                { Label: "Reduktion bzw. Vermeidung von Sturzgefahr" },
                { Label: "Erhalt bzw. Wiederherstellung der Selbstversorgung im häuslichen Milieu" },
                { Label: "Erhöhung der Lebensqualität!" },
                { Label: etwasAnderes }
            ];
        case options.indexOf("Multiple Sklerose") > -1:
            return [
                { Label: "Positive Beeinflussung Spastiken und MS-bedingten Schmerzen" },
                { Label: "Vermeidung von Krankenhausaufenthalten" },
                { Label: "Reduktion bzw. Vermeidung der starken und die Lebensqualität reduzierenden Nebenwirkungen der bisherigen Medikation" },
                { Label: "Reduktion von Medikamenten" },
                { Label: "Erhalt bzw. Wiederherstellung der Selbstversorgung im häuslichen Milieu" },
                { Label: "Multisymptomatischer Therapieansatz (Reduktion von Schmerzen und Angst, Stresssenkung, Regulation von Muskeltonus und Appetit)" },
                { Label: "Erhöhung der Lebensqualität!" },
                { Label: etwasAnderes }
            ];
        case options.indexOf("Tourette-Syndrom") > -1:
            return [
                { Label: "Positive Beeinflussung des Schmerzgedächtnisses um ein „Relearning“ (Umprogrammierung des Schmerzgedächtnisses zu erreichen)" },
                { Label: "Vermeidung von Krankenhausaufenthalten" },
                { Label: "Reduktion bzw. Vermeidung der starken und die Lebensqualität reduzierenden Nebenwirkungen der bisherigen Medikation" },
                { Label: "Reduktion von Medikamenten" },
                { Label: "Erhalt bzw. Wiederherstellung der Selbstversorgung im häuslichen Milieu" },
                { Label: "Multisymptomatischer Therapieansatz (Reduktion von Schmerzen und Angst, Stresssenkung, Regulation von Muskeltonus und Appetit)" },
                { Label: "Erhöhung der Lebensqualität!" },
                { Label: etwasAnderes }
            ];
        case options.indexOf("Epilepsie") > -1:
            return [
                { Label: "Verbesserung der Anfallskontrolle" },
                { Label: "Vermeidung von Krankenhausaufenthalten" },
                { Label: "Reduktion bzw. Vermeidung der starken und die Lebensqualität reduzierenden Nebenwirkungen der bisherigen Medikation" },
                { Label: "Reduktion von Medikamenten" },
                { Label: "Erhalt bzw. Wiederherstellung der Selbstversorgung im häuslichen Milieu" },
                { Label: "Erhöhung der Lebensqualität!" },
                { Label: etwasAnderes }
            ];
        case (options.indexOf("Schlafstörungen") > -1 || options.indexOf("ADHS") > -1 || options.indexOf("Posttraumatische Belastungsstörung") > -1):
            return [
                { Label: "Symptomkontrolle bei langjährig bestehender Erkrankung" },
                { Label: "Vermeidung von stationären Aufenthalten in der Psychiatrie" },
                { Label: "Reduktion bzw. Vermeidung der starken und die Lebensqualität reduzierenden Nebenwirkungen der bisherigen Medikation" },
                { Label: "Erhalt bzw. Wiederherstellung der Selbstversorgung im häuslichen Milieu" },
                { Label: "Erhöhung der Lebensqualität!" },
                { Label: etwasAnderes }
            ];
        case (options.indexOf("Depressionen") > -1 || options.indexOf("Schwere depressive Episode") > -1 || options.indexOf("Morbus Crohn") > -1 || options.indexOf("Angststörung") > -1):
            return [
                { Label: "Symptomkontrolle bei langjährig bestehender Erkrankung" },
                { Label: "Vermeidung von stationären Aufenthalten in der Psychiatrie" },
                { Label: "Reduktion bzw. Vermeidung der starken und die Lebensqualität reduzierenden Nebenwirkungen der bisherigen Medikation" },
                { Label: "Erhalt bzw. Wiederherstellung der Selbstversorgung im häuslichen Milieu" },
                { Label: "Erhöhung der Lebensqualität!" },
                { Label: etwasAnderes }
            ];
        default:
            return [
                { Label: "Reduzierung der Nebenwirkungen durch Standardtherapie" },
                { Label: "Verhinderung von Krankenhausaufenthalten" },
                { Label: "Reduktion bzw. Vermeidung der starken und die Lebensqualtiät reduzierenden Nebenwirkungen der bisherigen Medikation" },
                { Label: "Erhalt bzw. Wiederherstellung der Selbstversorgung im häuslichen Milieu" },
                { Label: etwasAnderes }
            ];
    }
}

export const QuestTwelveOptions = (options) => {
    switch (true) {
        case (options.indexOf("Schmerz") > -1 || options.indexOf("Chronische unbeeinflussbare Schmerzen") > -1 || options.indexOf("Chronische rheumatische Neuritis") > -1 || options.indexOf("Fibromyalgie") > -1):
            return [
                { Label: "Diverse NSAR nicht mehr eingesetzt wegen starker gastrointestinaler Nebenwirkungen" },
                { Label: "Schwache Opioide ungenügende Wirksamkeit bei starken Nebenwirkungen (Übelkeit und Erbrechen)" },
                { Label: "Starke Opioide wegen folgender NW abgesetzt bzw. nicht weiter steigerbar: Übelkeit, Obstipation, Schwindel, Sturzgefahr, Libidoverlust, Kontraindiziert wegen u. g. Begleiterkrankungen)" },
                { Label: "Physiotherapie im Rahmen der Kassenleistung ausgeschöpft" },
                { Label: "Psychotherapie" },
                { Label: "Multimodale Schmerztherapie" },
                { Label: stationareFreitext },
                { Label: etwasAnderes }
            ];
        case (options.indexOf("Spastik") > -1 || options.indexOf("Parkinson") > -1):
            return [
                { Label: "Standardtherapie mit nur ungenügender Wirksamkeit bei starken Nebenwirkungen" },
                { Label: "Standardtherapie abgesetzt bzw. nicht weiter steigerbar: Schwindel, Sturzgefahr, Libidoverlust, Kontraindiziert" },
                { Label: "Physiotherapie im Rahmen der Kassenleistung ausgeschöpft" },
                { Label: "Psychotherapie" },
                { Label: "Multimodale Schmerztherapie" },
                { Label: etwasAnderes }
            ];
        case options.indexOf("Übelkeit und Erbrechen") > -1:
            return [
                { Label: "Standardtherapie mit nur ungenügender Wirksamkeit bei starken Nebenwirkungen" },
                { Label: "Standardtherapie abgesetzt bzw. nicht weiter steigerbar: Schwindel, Sturzgefahr, Libidoverlust, Kontraindiziert" },
                { Label: "Psychotherapie" },
                { Label: "Multimodale Schmerztherapie" },
                { Label: etwasAnderes }
            ];
        case options.indexOf("Appetitlosigkeit") > -1:
            return [
                { Label: "Diverse Therapien nicht mehr eingesetzt wegen starker Nebenwirkungen" },
                { Label: "Physiotherapie im Rahmen der Kassenleistung ausgeschöpft" },
                { Label: "Psychotherapie" },
                { Label: "Multimodale Schmerztherapie" },
                { Label: stationareFreitext },
                { Label: etwasAnderes }
            ];
        case options.indexOf("Multiple Sklerose") > -1:
            return [
                { Label: "Diverse Medikamente nicht mehr eingesetzt wegen: starker gastrointst. Bzw. allergischer  NW" },
                { Label: "Standardtherapie abgesetzt bzw. nicht weiter steigerbar: Schwindel, Sturzgefahr, Libidoverlust, Kontraindiziert" },
                { Label: "Physiotherapie im Rahmen der Kassenleistung ausgeschöpft" },
                { Label: "Psychotherapie" },
                { Label: "Multimodale Schmerztherapie" },
                { Label: stationareFreitext },
                { Label: etwasAnderes }
            ];
        case options.indexOf("Tourette-Syndrom") > -1:
            return [
                { Label: "Diverse NSAR nicht mehr eingesetzt wegen: starker gastrointst. Bzw. allergischer  NW" },
                { Label: "Schwache Opioide ungenügende Wirksamkeit bei starken Nebenwirkungen (Übelkeit und Erbrechen)" },
                { Label: "Starke Opioide wegen folgender NW abgesetzt bzw. nicht weiter steigerbar: Übelkeit, Obstipation, Schwindel, Sturzgefahr, Libidoverlust, Kontraindiziert wegen u. g. Begleiterkrankungen)" },
                { Label: "Physiotherapie im Rahmen der Kassenleistung ausgeschöpft" },
                { Label: "Psychotherapie" },
                { Label: "Multimodale Schmerztherapie" },
                { Label: stationareFreitext },
                { Label: etwasAnderes }
            ];
        case options.indexOf("Epilepsie") > -1:
            return [
                { Label: "Diverse Antiepileptika nicht mehr eingesetzt wegen starker Nebenwirkungen" },
                { Label: "Bisherige Therapie mit ungenügender Wirksamkeit bei starken Nebenwirkungen" },
                { Label: "Einzig wirksame Therapie ist Kontraindiziert wegen subakuter/protrahierter Leberinsuffizienz" },
                { Label: "Physiotherapie im Rahmen der Kassenleistung ausgeschöpft" },
                { Label: "Psychotherapie" },
                { Label: "Multimodale Schmerztherapie" },
                { Label: stationareFreitext },
                { Label: etwasAnderes }
            ];
        case options.indexOf("Morbus Crohn") > -1:
            return [
                { Label: "Diverse leitliniengerechte Medikamente nicht mehr eingesetzt wegen starker Nebenwirkungen" },
                { Label: "Bisherige Therapie mit ungenügender Wirksamkeit bei starken Nebenwirkungen" },
                { Label: "Einzig wirksame Therapie ist Kontraindiziert wegen subakuter/protrahierter Leberinsuffizienz" },
                { Label: "Allgemeine Therapien ohne Erfolg (Lactosefreie Diät, Ballaststoff-Vermeidung)" },
                { Label: "Multimodale Schmerztherapie" },
                { Label: stationareFreitext }
            ];
        case (options.indexOf("Schlafstörungen") > -1 || options.indexOf("ADHS") > -1):
            return [
                { Label: "Diverse Antidepressiva nicht mehr eingesetzt wegen starker Nebenwirkungen" },
                { Label: "Bisherige Therapie mit ungenügender Wirksamkeit bei starken Nebenwirkungen" },
                { Label: "Einzig wirksame Therapie ist Kontraindiziert" },
                { Label: "Psychotherapie" },
                { Label: "Multimodale Schmerztherapie" },
                { Label: stationareFreitext }
            ];
        case (options.indexOf("Posttraumatische Belastungsstörung") > -1):
            return [
                { Label: "Diverse Antidepressiva nicht mehr eingesetzt wegen starker Nebenwirkungen" },
                { Label: "Bisherige Therapie mit ungenügender Wirksamkeit bei starken Nebenwirkungen" },
                { Label: "EMDR (Eye Movement Desensitization and Reprocessing) ist Kontraindiziert" },
                { Label: "Psychotherapie (Trauma fokussierte kognitive Verhaltenstherapie" },
                { Label: "Stationäre Aufenthalte" },
                { Label: "Multimodale Schmerztherapie" },
                { Label: stationareFreitext }
            ];
        case (options.indexOf("Depressionen") > -1 || options.indexOf("Schwere depressive Episode") > -1 || options.indexOf("Angststörung") > -1):
            return [
                { Label: "Diverse Antidepressiva nicht mehr eingesetzt wegen starker Nebenwirkungen" },
                { Label: "Bisherige Therapie mit ungenügender Wirksamkeit bei starken Nebenwirkungen" },
                { Label: "Einzig wirksame Therapie ist Kontraindiziert" },
                { Label: "Psychotherapie" },
                { Label: "Multimodale Schmerztherapie" },
                { Label: stationareFreitext }
            ];
        default:
            return [
                { Label: "Diverse NSAR nicht mehr eingesetzt wegen starker gastrointestinaler Nebenwirkungen" },
                { Label: "Schwache Opioide ungenügende Wirksamkeit bei starken Nebenwirkungen (Übelkeit und Erbrechen)" },
                { Label: "Starke Opioide wegen folgender NW abgesetzt bzw. nicht weiter steigerbar: Übelkeit, Obstipation, Schwindel, Sturzgefahr, Libidoverlust, Kontraindiziert wegen u. g. Begleiterkrankungen)" },
                { Label: "Physiotherapie im Rahmen der Kassenleistung ausgeschöpft" },
                { Label: "Psychotherapie" },
                { Label: "Multimodale Schmerztherapie" },
                { Label: stationareFreitext },
                { Label: etwasAnderes }
            ];
    }
}

export const QuestSeventeenOptions: FifteenOption[] = [
    {
        "Kasse": "actimonda BKK",
        "Strasse": "Hüttenstraße 1",
        "PLZ": "52068",
        "Ort": "Aachen"
    },
    {
        "Kasse": "AOK - Die Gesundheitskasse für Niedersachsen",
        "Strasse": "Hildesheimer Straße 273",
        "PLZ": "30519",
        "Ort": "Hannover"
    },
    {
        "Kasse": "AOK - Die Gesundheitskasse in Hessen",
        "Strasse": "Basler Straße 2",
        "PLZ": "61352",
        "Ort": "Bad Homburg"
    },
    {
        "Kasse": "AOK Baden-Württemberg",
        "Strasse": "Presselstraße 19",
        "PLZ": "70191",
        "Ort": "Stuttgart"
    },
    {
        "Kasse": "AOK Bayern - Die Gesundheitskasse",
        "Strasse": "Carl-Wery-Straße 28",
        "PLZ": "81739",
        "Ort": "München"
    },
    {
        "Kasse": "AOK Bremen / Bremerhaven",
        "Strasse": "Bürgermeister-Smidt-Str. 95",
        "PLZ": "28195",
        "Ort": "Bremen"
    },
    {
        "Kasse": "AOK Nordost - Die Gesundheitskasse",
        "Strasse": "Behlertstraße 33 A",
        "PLZ": "14467",
        "Ort": "Potsdam"
    },
    {
        "Kasse": "AOK NordWest - Die Gesundheitskasse",
        "Strasse": "Kopenhagener Str. 1",
        "PLZ": "44269",
        "Ort": "Dortmund"
    },
    {
        "Kasse": "AOK PLUS - Die Gesundheitskasse für Sachsen und Thüringen",
        "Strasse": "Sternplatz 7",
        "PLZ": "01067",
        "Ort": "Dresden"
    },
    {
        "Kasse": "AOK Rheinland-Pfalz/Saarland-Die Gesundheitskasse",
        "Strasse": "Virchowstraße 30",
        "PLZ": "67304",
        "Ort": "Eisenberg"
    },
    {
        "Kasse": "AOK Rheinland/Hamburg - Die Gesundheitskasse",
        "Strasse": "Kasernenstraße 61",
        "PLZ": "40213",
        "Ort": "Düsseldorf"
    },
    {
        "Kasse": "AOK Sachsen-Anhalt - Die Gesundheitskasse",
        "Strasse": "Lüneburger Str. 4",
        "PLZ": "39106",
        "Ort": "Magdeburg"
    },
    {
        "Kasse": "atlas BKK ahlmann",
        "Strasse": "Am Kaffee-Quartier 3",
        "PLZ": "28217",
        "Ort": "Bremen"
    },
    {
        "Kasse": "Audi BKK",
        "Strasse": "Ettinger Str. 70",
        "PLZ": "85057",
        "Ort": "Ingolstadt"
    },
    {
        "Kasse": "BAHN-BKK",
        "Strasse": "Franklinstrasse 54",
        "PLZ": "60486",
        "Ort": "Frankfurt"
    },
    {
        "Kasse": "BARMER",
        "Strasse": "Axel-Springer-Straße 44",
        "PLZ": "10969",
        "Ort": "Berlin"
    },
    {
        "Kasse": "Bertelsmann BKK",
        "Strasse": "Carl-Miele-Str. 214",
        "PLZ": "33335",
        "Ort": "Gütersloh"
    },
    {
        "Kasse": "Betriebskrankenkasse Mobil Oil",
        "Strasse": "Friedenheimer Brücke 29",
        "PLZ": "80639",
        "Ort": "München"
    },
    {
        "Kasse": "Betriebskrankenkasse PricewaterhouseCoopers",
        "Strasse": "Burgstr. 1-3",
        "PLZ": "34212",
        "Ort": "Melsungen"
    },
    {
        "Kasse": "BIG direkt gesund",
        "Strasse": "Markgrafenstrasse 62",
        "PLZ": "10969",
        "Ort": "Berlin"
    },
    {
        "Kasse": "BKK Achenbach Buschhütten",
        "Strasse": "Siegener Str. 152",
        "PLZ": "57223",
        "Ort": "Kreuztal"
    },
    {
        "Kasse": "BKK Aesculap",
        "Strasse": "Jetterstraße 13/1",
        "PLZ": "78532",
        "Ort": "Tuttlingen"
    },
    {
        "Kasse": "BKK Akzo Nobel Bayern",
        "Strasse": "Glanzstoffstraße",
        "PLZ": "63785",
        "Ort": "Obernburg"
    },
    {
        "Kasse": "BKK B. Braun Melsungen AG",
        "Strasse": "Grüne Str. 1",
        "PLZ": "34212",
        "Ort": "Melsungen"
    },
    {
        "Kasse": "BKK BPW Bergische Achsen KG",
        "Strasse": "Ohler Berg 1",
        "PLZ": "51674",
        "Ort": "Wiehl"
    },
    {
        "Kasse": "BKK Deutsche Bank AG",
        "Strasse": "Königsallee 60c",
        "PLZ": "40212",
        "Ort": "Düsseldorf"
    },
    {
        "Kasse": "BKK Diakonie",
        "Strasse": "Königsweg 8",
        "PLZ": "33617",
        "Ort": "Bielefeld"
    },
    {
        "Kasse": "BKK EUREGIO",
        "Strasse": "Boos-Fremery-Straße 62",
        "PLZ": "52525",
        "Ort": "Heinsberg"
    },
    {
        "Kasse": "BKK EVM",
        "Strasse": "Schützenstr 80 - 82",
        "PLZ": "56068",
        "Ort": "Koblenz"
    },
    {
        "Kasse": "BKK EWE",
        "Strasse": "Staulinie 16-17",
        "PLZ": "26122",
        "Ort": "Oldenburg"
    },
    {
        "Kasse": "BKK exklusiv",
        "Strasse": "Zum Blauen See 7",
        "PLZ": "31275",
        "Ort": "Lehrte"
    },
    {
        "Kasse": "BKK Faber-Castell & Partner",
        "Strasse": "Bahnhofstraße 45",
        "PLZ": "94209",
        "Ort": "Regen"
    },
    {
        "Kasse": "BKK firmus",
        "Strasse": "Gottlieb-Daimler Str. 11",
        "PLZ": "28237",
        "Ort": "Bremen"
    },
    {
        "Kasse": "BKK Freudenberg",
        "Strasse": "Höhnerweg 2 - 4",
        "PLZ": "69469",
        "Ort": "Weinheim"
    },
    {
        "Kasse": "BKK Gildemeister Seidensticker",
        "Strasse": "Winterstr. 49",
        "PLZ": "33649",
        "Ort": "Bielefeld"
    },
    {
        "Kasse": "BKK GRILLO-WERKE AG",
        "Strasse": "Weseler Str. 1",
        "PLZ": "47169",
        "Ort": "Duisburg"
    },
    {
        "Kasse": "BKK Groz-Beckert",
        "Strasse": "Unter dem Malesfelsen 72",
        "PLZ": "72458",
        "Ort": "Albstadt"
    },
    {
        "Kasse": "BKK HENSCHEL Plus",
        "Strasse": "Josef-Fischer-Str. 10",
        "PLZ": "34127",
        "Ort": "Kassel"
    },
    {
        "Kasse": "BKK Herford Minden Ravensberg",
        "Strasse": "Am Kleinbahnhof 5",
        "PLZ": "32051",
        "Ort": "Herford"
    },
    {
        "Kasse": "BKK Herkules",
        "Strasse": "Jordanstr. 6",
        "PLZ": "34117",
        "Ort": "Kassel"
    },
    {
        "Kasse": "BKK KARL MAYER",
        "Strasse": "Industriestraße 3",
        "PLZ": "63179",
        "Ort": "Obertshausen"
    },
    {
        "Kasse": "BKK KBA",
        "Strasse": "Friedrich-Koenig-Str. 4",
        "PLZ": "97080",
        "Ort": "Würzburg"
    },
    {
        "Kasse": "BKK Linde",
        "Strasse": "Konrad-Adenauer-Ring 33",
        "PLZ": "65187",
        "Ort": "Wiesbaden"
    },
    {
        "Kasse": "BKK MAHLE",
        "Strasse": "Pragstr. 26-46",
        "PLZ": "70376",
        "Ort": "Stuttgart"
    },
    {
        "Kasse": "BKK Melitta Plus",
        "Strasse": "Marienstr. 122",
        "PLZ": "32425",
        "Ort": "Minden"
    },
    {
        "Kasse": "BKK Miele",
        "Strasse": "Carl-Miele-Straße 29",
        "PLZ": "33332",
        "Ort": "Gütersloh"
    },
    {
        "Kasse": "BKK MTU",
        "Strasse": "Hochstraße 40",
        "PLZ": "88045",
        "Ort": "Friedrichshafen"
    },
    {
        "Kasse": "BKK PFAFF",
        "Strasse": "Pirmasenser Str. 132",
        "PLZ": "67655",
        "Ort": "Kaiserslautern"
    },
    {
        "Kasse": "BKK Pfalz",
        "Strasse": "Lichtenberger Str. 16",
        "PLZ": "67059",
        "Ort": "Ludwigshafen"
    },
    {
        "Kasse": "BKK ProVita",
        "Strasse": "Münchner Weg 5",
        "PLZ": "85232",
        "Ort": "Bergkirchen"
    },
    {
        "Kasse": "BKK Public",
        "Strasse": "Thiestrasse 15",
        "PLZ": "38226",
        "Ort": "Salzgitter"
    },
    {
        "Kasse": "BKK Rieker.RICOSTA.Weisser",
        "Strasse": "Stockacher Str. 4-6",
        "PLZ": "78532",
        "Ort": "Tuttlingen"
    },
    {
        "Kasse": "BKK RWE",
        "Strasse": "Welfenallee 32",
        "PLZ": "29225",
        "Ort": "Celle"
    },
    {
        "Kasse": "BKK Salzgitter",
        "Strasse": "Thiestrasse 15",
        "PLZ": "38226",
        "Ort": "Salzgitter"
    },
    {
        "Kasse": "BKK Scheufelen",
        "Strasse": "Schöllkopfstr. 120",
        "PLZ": "73230",
        "Ort": "Kirchheim"
    },
    {
        "Kasse": "BKK Schwarzwald-Baar-Heuberg",
        "Strasse": "Löhrstraße 45",
        "PLZ": "78647",
        "Ort": "Trossingen"
    },
    {
        "Kasse": "BKK STADT AUGSBURG",
        "Strasse": "Willy-Brandt-Platz 1",
        "PLZ": "86153",
        "Ort": "Augsburg"
    },
    {
        "Kasse": "BKK Technoform",
        "Strasse": "August-Spindler-Straße 1",
        "PLZ": "37079",
        "Ort": "Göttingen"
    },
    {
        "Kasse": "BKK Textilgruppe Hof",
        "Strasse": "Fabrikzeile 21",
        "PLZ": "95028",
        "Ort": "Hof"
    },
    {
        "Kasse": "BKK VDN",
        "Strasse": "Rosenweg 15",
        "PLZ": "58239",
        "Ort": "Schwerte"
    },
    {
        "Kasse": "BKK VerbundPlus",
        "Strasse": "Karloninenplatz 5",
        "PLZ": "80333",
        "Ort": "München"
    },
    {
        "Kasse": "BKK Verkehrsbau Union (VBU)",
        "Strasse": "Lindenstraße 67",
        "PLZ": "10969",
        "Ort": "Berlin"
    },
    {
        "Kasse": "BKK Voralb HELLER*INDEX*LEUZE",
        "Strasse": "Neuffener Straße 54",
        "PLZ": "72622",
        "Ort": "Nürtingen"
    },
    {
        "Kasse": "BKK Werra-Meissner",
        "Strasse": "Straßburger Str. 5",
        "PLZ": "37269",
        "Ort": "Eschwege"
    },
    {
        "Kasse": "BKK Wirtschaft & Finanzen",
        "Strasse": "Bahnhofstr. 19",
        "PLZ": "34212",
        "Ort": "Melsungen"
    },
    {
        "Kasse": "BKK Würth",
        "Strasse": "Gartenstraße 11",
        "PLZ": "74653",
        "Ort": "Künzelsau"
    },
    {
        "Kasse": "BKK ZF & Partner",
        "Strasse": "Am Wöllershof 12",
        "PLZ": "56068",
        "Ort": "Koblenz"
    },
    {
        "Kasse": "BKK_DürkoppAdler",
        "Strasse": "Potsdamer Str. 190",
        "PLZ": "33719",
        "Ort": "Bielefeld"
    },
    {
        "Kasse": "BKK24",
        "Strasse": "Sülbecker Brand 1",
        "PLZ": "31683",
        "Ort": "Obernkirchen"
    },
    {
        "Kasse": "BMW BKK",
        "Strasse": "Mengkofener Str.  6",
        "PLZ": "84130",
        "Ort": "Dingolfing"
    },
    {
        "Kasse": "Bosch BKK",
        "Strasse": "Kruppstr. 19",
        "PLZ": "70469",
        "Ort": "Stuttgart"
    },
    {
        "Kasse": "Brandenburgische BKK",
        "Strasse": "Werkstraße 10",
        "PLZ": "15890",
        "Ort": "Eisenhüttenstadt"
    },
    {
        "Kasse": "Continentale Betriebskrankenkasse",
        "Strasse": "Sengelmannstrasse 120",
        "PLZ": "22335",
        "Ort": "Hamburg"
    },
    {
        "Kasse": "Daimler Betriebskrankenkasse",
        "Strasse": "Mercedesstraße  139",
        "PLZ": "70327",
        "Ort": "Stuttgart"
    },
    {
        "Kasse": "DAK-Gesundheit",
        "Strasse": "Nagelsweg 27-31",
        "PLZ": "20097",
        "Ort": "Hamburg"
    },
    {
        "Kasse": "Debeka BKK",
        "Strasse": "Im Metternicher Feld 40",
        "PLZ": "56072",
        "Ort": "Koblenz"
    },
    {
        "Kasse": "DIE BERGISCHE KRANKENKASSE",
        "Strasse": "Heresbachstr. 29",
        "PLZ": "42719",
        "Ort": "Solingen"
    },
    {
        "Kasse": "Die Schwenninger Betriebskrankenkasse",
        "Strasse": "Spittelstr. 50",
        "PLZ": "78056",
        "Ort": "Villingen-Schwenningen"
    },
    {
        "Kasse": "energie-Betriebskrankenkasse",
        "Strasse": "Lange Laube 6",
        "PLZ": "30159",
        "Ort": "Hannover"
    },
    {
        "Kasse": "Ernst & Young BKK",
        "Strasse": "Arnulfstr. 59",
        "PLZ": "80636",
        "Ort": "München"
    },
    {
        "Kasse": "Hanseatische Krankenkasse",
        "Strasse": "Wandsbeker Zollstraße 86-90",
        "PLZ": "22041",
        "Ort": "Hamburg"
    },
    {
        "Kasse": "Heimat Krankenkasse",
        "Strasse": "Herforder Str. 23",
        "PLZ": "33602",
        "Ort": "Bielefeld"
    },
    {
        "Kasse": "hkk",
        "Strasse": "Martinistraße 26",
        "PLZ": "28195",
        "Ort": "Bremen"
    },
    {
        "Kasse": "IKK Brandenburg und Berlin",
        "Strasse": "Ziolkowskistr. 6",
        "PLZ": "14480",
        "Ort": "Potsdam"
    },
    {
        "Kasse": "IKK classic",
        "Strasse": "Tannenstr. 4b",
        "PLZ": "01099",
        "Ort": "Dresden"
    },
    {
        "Kasse": "IKK gesund plus",
        "Strasse": "Umfassungsstraße 85",
        "PLZ": "39124",
        "Ort": "Magdeburg"
    },
    {
        "Kasse": "IKK Nord",
        "Strasse": "Lachswehrallee 1",
        "PLZ": "23558",
        "Ort": "Lübeck"
    },
    {
        "Kasse": "IKK Südwest",
        "Strasse": "Berliner Promenade 1",
        "PLZ": "66111",
        "Ort": "Saarbrücken"
    },
    {
        "Kasse": "Kaufmännische Krankenkasse - KKH",
        "Strasse": "Karl-Wiechert-Allee 61",
        "PLZ": "30625",
        "Ort": "Hannover"
    },
    {
        "Kasse": "Knappschaft",
        "Strasse": "Knappschaftsstraße 1",
        "PLZ": "44799",
        "Ort": "Bochum"
    },
    {
        "Kasse": "Krones BKK",
        "Strasse": "Bayerwaldstr. 2L",
        "PLZ": "93073",
        "Ort": "Neutraubling"
    },
    {
        "Kasse": "Merck BKK",
        "Strasse": "Frankfurter Straße 130",
        "PLZ": "64293",
        "Ort": "Darmstadt"
    },
    {
        "Kasse": "Metzinger BKK",
        "Strasse": "Stuttgarter Straße 15+17",
        "PLZ": "72555",
        "Ort": "Metzingen"
    },
    {
        "Kasse": "mhplus Betriebskrankenkasse",
        "Strasse": "Nordostpark 14",
        "PLZ": "90411",
        "Ort": "Nürnberg"
    },
    {
        "Kasse": "Novitas BKK",
        "Strasse": "Schifferstraße 92-102",
        "PLZ": "47059",
        "Ort": "Duisburg"
    },
    {
        "Kasse": "pronova BKK",
        "Strasse": "Brunckstr. 47",
        "PLZ": "67063",
        "Ort": "Ludwigshafen"
    },
    {
        "Kasse": "R+V Betriebskrankenkasse",
        "Strasse": "Kreuzberger Ring 21",
        "PLZ": "65205",
        "Ort": "Wiesbaden"
    },
    {
        "Kasse": "Salus BKK",
        "Strasse": "Züricher Straße 27",
        "PLZ": "81476",
        "Ort": "München"
    },
    {
        "Kasse": "SECURVITA BKK",
        "Strasse": "Lübeckertordamm 1-3",
        "PLZ": "20099",
        "Ort": "Hamburg"
    },
    {
        "Kasse": "SIEMAG BKK",
        "Strasse": "Hillnhütter Str. 89",
        "PLZ": "57271",
        "Ort": "Hilchenbach"
    },
    {
        "Kasse": "Siemens-Betriebskrankenkasse (SBK)",
        "Strasse": "In den Seewiesen",
        "PLZ": "89520",
        "Ort": "Heidenheim"
    },
    {
        "Kasse": "SKD BKK",
        "Strasse": "Schultesstrasse 19a",
        "PLZ": "97421",
        "Ort": "Schweinfurt"
    },
    {
        "Kasse": "Sozialversicherung für Landwirtschaft, Forsten und Gartenbau (SVLFG)",
        "Strasse": "Weißensteinstraße 70-72",
        "PLZ": "34131",
        "Ort": "Kassel"
    },
    {
        "Kasse": "Südzucker BKK",
        "Strasse": "Joseph-Meyer-Str. 13-15",
        "PLZ": "68167",
        "Ort": "Mannheim"
    },
    {
        "Kasse": "Techniker Krankenkasse",
        "Strasse": "Bramfelder Str. 140",
        "PLZ": "22305",
        "Ort": "Hamburg"
    },
    {
        "Kasse": "Thüringer Betriebskrankenkasse",
        "Strasse": "Stotternheimer Str. 9a",
        "PLZ": "99086",
        "Ort": "Erfurt"
    },
    {
        "Kasse": "TUI BKK",
        "Strasse": "Karl-Wiechert-Allee 23",
        "PLZ": "30625",
        "Ort": "Hannover"
    },
    {
        "Kasse": "VIACTIV Krankenkasse",
        "Strasse": "Universitätsstraße 43",
        "PLZ": "44789",
        "Ort": "Bochum"
    },
    {
        "Kasse": "Wieland BKK",
        "Strasse": "Graf-Arco-Str. 36",
        "PLZ": "89079",
        "Ort": "Ulm"
    },
    {
        "Kasse": "WMF Betriebskrankenkasse",
        "Strasse": "Eberhardstraße",
        "PLZ": "73312",
        "Ort": "Geislingen"
    }
];
